// {
//     name: 'CARRYON 22FW',
//     subTitle: '',
//     list: [
//         // 連帽上衣
//         {
//             sku: '22FW hoodie-BK1',
//             caption: 'CARRYON 22FW Energy Hoodie 閃電 連帽上衣 黑',
//             spec: 'L-2XL',
//             specImg: '/image/product/2023-01/size/CARRYON 22FW Energy Hoodie 閃電 連帽上衣.webp',
//             buyLink: 'https://forms.gle/vSbryNK3k9KQq8bE6',
//             price: 1680,
//             // specialOffer: 980,
//             inStock: true,
//             image: '/image/product/2023-01/hoodie_bk1',
//             fittingDesc: [
//                 ['Female', 'Height：159cm', 'Weight：44kg', 'Size：L', '寬鬆'],
//                 ['Male', 'Height：174cm', 'Weight：63kg', 'Size：XL', '寬鬆'],
//             ],
//             desc: `CARRYON 22FW Energy Hoodie 閃電 連帽上衣 黑

//             推出首次獨特版型，寬鬆剪裁、無口袋無抽繩、下擺縮口羅紋材質縮短，袖口細節處置入全新織標，版型俐落乾淨，以舒適面料為底，觸感柔軟不起毛球，專注生活穿搭實用性，為薄款連帽上衣，可穿著運動、逛街等，外面可多層式搭配，不過於太悶熱！具備適度份量感

//             胸前藍色閃電象徵「能量」
//             提倡大家累了該好好休息
//             為自己充電，再充滿電的下一次
//             重新帶著這份的能量 繼續發熱吧！

//             【注意事項】確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨

//             【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主

//             【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
//             prodDescImgs: [
//                 // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
//                 // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
//             ],
//             descImgs: [
//                 '/image/product/2023-01/desc/CARRYON 22FW 連帽上衣 黑/1.png',
//                 '/image/product/2023-01/desc/CARRYON 22FW 連帽上衣 黑/2.png',
//                 '/image/product/2023-01/desc/CARRYON 22FW 連帽上衣 黑/3.png',
//                 '/image/product/2023-01/desc/CARRYON 22FW 連帽上衣 黑/4.png',
//                 '/image/product/2023-01/desc/CARRYON 22FW 連帽上衣 黑/5.png',
//             ]
//         },
//     ]
// },

const prods = [
    {
        source: 'aws',
        name: '24SS Chillax',
        subTitle: '',
        list: [
            { "sku": "SS24W02-BL", "caption": "CARRYON 24SS Soccer Jersey 拼接透氣落肩 短T 黑籃", "spec": "M-XL", "specImg": "", "buyLink": "https://forms.gle/CGuYefzz51SArYu96", "price": 1080, "specialOffer": null, "inStock": true, "image": "", "series": "24SS Chillax", "fittingDesc": [["Female", "Height：159cm", "Weight：44kg", "Size：M", "合適"], ["Male", "Height：173cm", "Weight：57kg", "Size：L", "合適"]], "desc": "CARRYON 24SS \n\nSoccer Jersey 拼接透氣落肩 短T\n\nJust Chill, everything’s going to be OK\n\n放輕鬆，一切都會更好\n\n｜昇華材質、排汗舒適 ｜\n\n價格：$1080\n配色：黑藍、黑金\n尺寸：M-XL\n\n｜購物須知 ｜\n\n首波現貨會按照登記順序出貨\n現貨完售後接受預購，預購至8/18截止，工作日7-14天\n經銷點將於 8/11 上架販售\n\nMade in Taiwan\n\n｜注意事項 ｜\n\n欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主\n\nwww.carryon-clothing.com", "prodDescImgs": [], "descImgs": [], "prodImgLength": 5, "hasSpecImg": 1, "descImgLength": 5 },
            { "sku": "SS24W02-BG", "caption": "CARRYON 24SS Soccer Jersey 拼接透氣落肩 短T 黑金", "spec": "M-XL", "specImg": "", "buyLink": "https://forms.gle/CGuYefzz51SArYu96", "price": 1080, "specialOffer": null, "inStock": true, "image": "", "series": "24SS Chillax", "fittingDesc": [["Female", "Height：159cm", "Weight：44kg", "Size：M", "合適"], ["Male", "Height：173cm", "Weight：57kg", "Size：L", "合適"]], "desc": "CARRYON 24SS \n\nSoccer Jersey 拼接透氣落肩 短T\n\nJust Chill, everything’s going to be OK\n\n放輕鬆，一切都會更好\n\n｜昇華材質、排汗舒適 ｜\n\n價格：$1080\n配色：黑藍、黑金\n尺寸：M-XL\n\n｜購物須知 ｜\n\n首波現貨會按照登記順序出貨\n現貨完售後接受預購，預購至8/18截止，工作日7-14天\n經銷點將於 8/11 上架販售\n\nMade in Taiwan\n\n｜注意事項 ｜\n\n欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主\n\nwww.carryon-clothing.com", "prodDescImgs": [], "descImgs": [], "prodImgLength": 5, "hasSpecImg": 1, "descImgLength": 5 },
            { "sku": "SS24W01-BK", "caption": "CARRYON 24SS Chillax Logo Tee 厚磅短T 黑色", "spec": "M-XXL", "specImg": "", "buyLink": "https://forms.gle/CGuYefzz51SArYu96", "comingSoon": false, "price": 1280, "specialOffer": null, "inStock": true, "image": "", "series": "24SS Chillax", "fittingDesc": [["Female", "Height：159cm", "Weight：44kg", "Size：M", "合適"], ["Male", "Height：173cm", "Weight：57kg", "Size：L", "合適"]], "desc": "CARRYON 24SS \n\nChillax Logo Tee 厚磅短T\n\nJust Chill, everything’s going to be OK\n\n放輕鬆，一切都會更好\n\n｜版型挺、高磅數 ｜\n\n價格：$1280 \n配色：黑色、水洗灰\n尺寸：M-XXL\n\n｜購物須知 ｜\n\n首波現貨會按照登記順序出貨\n現貨完售後接受預購，預購至8/18截止，工作日7-14天\n經銷點將於 8/11 上架販售\n\nMade in Taiwan\n\n｜注意事項 ｜\n\n欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主\n\nwww.carryon-clothing.com", "prodDescImgs": [], "descImgs": [], "prodImgLength": 5, "hasSpecImg": 1, "descImgLength": 5 },
            { "sku": "SS24W01-GY", "caption": "CARRYON 24SS Chillax Logo Tee 厚磅短T 水洗灰", "spec": "M-XXL", "specImg": "", "buyLink": "https://forms.gle/CGuYefzz51SArYu96", "comingSoon": false, "price": 1280, "specialOffer": null, "inStock": true, "image": "", "series": "24SS Chillax", "fittingDesc": [["Female", "Height：159cm", "Weight：44kg", "Size：M", "合適"], ["Male", "Height：173cm", "Weight：57kg", "Size：L", "合適"]], "desc": "CARRYON 24SS \n\nChillax Logo Tee 厚磅短T\n\nJust Chill, everything’s going to be OK\n\n放輕鬆，一切都會更好\n\n｜版型挺、高磅數 ｜\n\n價格：$1280 \n配色：黑色、水洗灰\n尺寸：M-XXL\n\n｜購物須知 ｜\n\n首波現貨會按照登記順序出貨\n現貨完售後接受預購，預購至8/18截止，工作日7-14天\n經銷點將於 8/11 上架販售\n\nMade in Taiwan\n\n｜注意事項 ｜\n\n欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主\n\nwww.carryon-clothing.com", "prodDescImgs": [], "descImgs": [], "prodImgLength": 5, "hasSpecImg": 1, "descImgLength": 5 },
            { "sku": "SS24W03-CJ", "caption": "CARRYON 24SS Classics jeans 寬鬆牛仔褲 淺藍", "spec": "30-34", "specImg": "", "buyLink": "https://forms.gle/CGuYefzz51SArYu96", "comingSoon": false, "price": 1580, "specialOffer": null, "inStock": true, "image": "", "series": "24SS Chillax", "fittingDesc": [["Female", "Height：159cm", "Weight：44kg", "Size：30", "合適"], ["Male", "Height：173cm", "Weight：57kg", "Size：32", "合適"]], "desc": "CARRYON 24SS \n\nClassics jeans 寬鬆牛仔褲 淺藍\n\nJust Chill, everything’s going to be OK\n\n放輕鬆，一切都會更好\n\n｜直筒版型、版型挺、修飾腿部比例 ｜\n\n價格：$1580\n尺寸：30-32-34\n\n｜購物須知 ｜\n\n首波現貨會按照登記順序出貨\n現貨完售後接受預購，預購至8/18截止，工作日7-14天\n經銷點將於 8/11 上架販售\n\nMade in Taiwan\n\n｜注意事項 ｜\n\n欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主\n\nwww.carryon-clothing.com", "prodDescImgs": [], "descImgs": [], "prodImgLength": 3, "hasSpecImg": 1, "descImgLength": 3 },
            { "sku": "SS24W03-BS", "caption": "CARRYON 24SS Baggy Short 水洗寬鬆牛仔短褲 深藍", "spec": "M-XL", "specImg": "", "buyLink": "https://forms.gle/CGuYefzz51SArYu96", "comingSoon": false, "price": 1280, "specialOffer": null, "inStock": true, "image": "", "series": "24SS Chillax", "fittingDesc": [["Female", "Height：159cm", "Weight：44kg", "Size：M", "合適"], ["Male", "Height：173cm", "Weight：57kg", "Size：L", "合適"]], "desc": "CARRYON 24SS \n\nBaggy Short 水洗寬鬆牛仔短褲 深藍\n\nJust Chill, everything’s going to be OK\n\n放輕鬆，一切都會更好\n\n｜直筒版型、版型挺｜\n\n價格：$1280\n尺寸：M-XL\n\n｜購物須知 ｜\n\n首波現貨會按照登記順序出貨\n現貨完售後接受預購，預購至8/18截止，工作日7-14天\n經銷點將於 8/11 上架販售\n\nMade in Taiwan\n\n｜注意事項 ｜\n\n欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主\n\nwww.carryon-clothing.com", "prodDescImgs": [], "descImgs": [], "prodImgLength": 3, "hasSpecImg": 1, "descImgLength": 3 }
        ]
    },
    {
        source: 'aws',
        name: '24SSLAB 2nd Release',
        subTitle: '',
        list: [
            { "sku": "LAB24SS-TankTop-BK", "caption": "[預購]  CARRYON LAB 24SS Logo Tank Top 透氣 短版背心 黑色", "spec": "S-L", "specImg": "", "buyLink": "https://forms.gle/9Avux45YtuCqMJnP9", "price": 680, "specialOffer": null, "inStock": true, "image": "", "series": "24SSLAB 2nd Release", "fittingDesc": [["Female", "Height：159cm", "Weight：44kg", "Size：S", ""], ["Female", "Height：166cm", "Weight：46kg", "Size：M", ""], ["Female", "Height：160cm", "Weight：47kg", "Size：S", ""]], "desc": "[預購]  CARRYON LAB 24SS Logo Tank Top 透氣 短版背心  \n\n價格：$1,280 \n配色：黑色、白色、深灰色\n尺寸：S、M、L \n\nCARRYON LAB專為女孩設計的精選選物支線\n帶給你最貼心的夏季穿搭體驗👩‍🦰\n\n這款背心是女孩夏天必備的單品\n材料透氣不悶熱\n讓你在炎熱的夏季也能感到清爽舒適☀️\n\n簡約的設計及質料\n無論是運動還是日常穿搭都適合\n\n⏰ 注意事項：商品將預購至6/30後，需等待7-10天時間後出貨\n\n 【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額 \n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n 【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主\"", "prodDescImgs": [], "descImgs": [], "prodImgLength": 4, "hasSpecImg": 1, "descImgLength": 4 },
            { "sku": "LAB24SS-TankTop-WH", "caption": "[預購]  CARRYON LAB 24SS Logo Tank Top 透氣 短版背心 白色", "spec": "S-L", "specImg": "", "buyLink": "https://forms.gle/9Avux45YtuCqMJnP9", "price": 680, "specialOffer": null, "inStock": true, "image": "", "series": "24SSLAB 2nd Release", "fittingDesc": [["Female", "Height：159cm", "Weight：44kg", "Size：S", ""], ["Female", "Height：166cm", "Weight：46kg", "Size：M", ""], ["Female", "Height：160cm", "Weight：47kg", "Size：S", ""]], "desc": "[預購]  CARRYON LAB 24SS Logo Tank Top 透氣 短版背心  \n\n價格：$1,280 \n配色：黑色、白色、深灰色\n尺寸：S、M、L \n\nCARRYON LAB專為女孩設計的精選選物支線\n帶給你最貼心的夏季穿搭體驗👩‍🦰\n\n這款背心是女孩夏天必備的單品\n材料透氣不悶熱\n讓你在炎熱的夏季也能感到清爽舒適☀️\n\n簡約的設計及質料\n無論是運動還是日常穿搭都適合\n\n⏰ 注意事項：商品將預購至6/30後，需等待7-10天時間後出貨\n\n 【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額 \n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n 【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主\"", "prodDescImgs": [], "descImgs": [], "prodImgLength": 4, "hasSpecImg": 1, "descImgLength": 4 }, { "sku": "LAB24SS-TankTop-GY", "caption": "[預購]  CARRYON LAB 24SS Logo Tank Top 透氣 短版背心 灰色", "spec": "S-L", "specImg": "", "buyLink": "https://forms.gle/9Avux45YtuCqMJnP9", "price": 680, "specialOffer": null, "inStock": true, "image": "", "series": "24SSLAB 2nd Release", "fittingDesc": [["Female", "Height：159cm", "Weight：44kg", "Size：S", ""], ["Female", "Height：166cm", "Weight：46kg", "Size：M", ""], ["Female", "Height：160cm", "Weight：47kg", "Size：S", ""]], "desc": "[預購]  CARRYON LAB 24SS Logo Tank Top 透氣 短版背心  \n\n價格：$1,280 \n配色：黑色、白色、深灰色\n尺寸：S、M、L \n\nCARRYON LAB專為女孩設計的精選選物支線\n帶給你最貼心的夏季穿搭體驗👩‍🦰\n\n這款背心是女孩夏天必備的單品\n材料透氣不悶熱\n讓你在炎熱的夏季也能感到清爽舒適☀️\n\n簡約的設計及質料\n無論是運動還是日常穿搭都適合\n\n⏰ 注意事項：商品將預購至6/30後，需等待7-10天時間後出貨\n\n 【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額 \n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n 【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主\"", "prodDescImgs": [], "descImgs": [], "prodImgLength": 4, "hasSpecImg": 1, "descImgLength": 4 },
            { "sku": "LAB24SS-CropTop", "caption": "[選物] CARRYON LAB Crop Top 假兩件復古美式短版上衣", "spec": "S-L", "specImg": "", "buyLink": "https://forms.gle/9Avux45YtuCqMJnP9", "price": 780, "specialOffer": null, "inStock": true, "image": "", "series": "24SSLAB 2nd Release", "fittingDesc": [["Female", "Height：160cm", "Weight：47kg", "Size：S", ""], ["image length", "Height：商品主圖片數量（幾張）", "Weight：", "Size：", ""], [4, "Height：", "Weight：", "Size：", ""]], "desc": "[選物] CARRYON LAB Crop Top 假兩件復古美式短版上衣\n\n價格：$780\n尺寸：S、M、L \n\n復古美式設計\n假兩件短版上衣為增加層次感\n超柔軟透氣的面料，適合夏季穿搭\n\n帥酷女孩千萬別錯過🩶\n\n⏰ 注意事項：商品將預購至6/30後，需等待7-10天時間後出貨\n\n 【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額 \n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n 【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主\"", "prodDescImgs": [], "descImgs": [], "prodImgLength": "specImg", "hasSpecImg": "descImg length", "descImgLength": "" }, { "sku": "LAB24SS-DenimSkirt", "caption": "[選物] CARRYON LAB Denim Skirt 工裝牛仔 長裙", "spec": "S-L", "specImg": "", "buyLink": "https://forms.gle/9Avux45YtuCqMJnP9", "price": 980, "specialOffer": null, "inStock": true, "image": "", "series": "24SSLAB 2nd Release", "fittingDesc": [["Female", "Height：166cm", "Weight：46kg", "Size：M", ""], ["Female", "Height：160cm", "Weight：47kg", "Size：S", ""], ["image length", "Height：商品主圖片數量（幾張）", "Weight：", "Size：", ""]], "desc": "[選物] CARRYON LAB Denim Skirt 工裝牛仔 長裙\n\n價格：$980\n尺寸：S、M、L \n\n20204年流行裙裝混搭\n穿搭風格越來越多元\n\nCARRYON LAB首次挑選牛仔長裙\n為女孩專挑最適合的個性穿搭\n既不會太帥氣也保留一點女孩氣質\n\n側邊還有口袋可以放置小物\n可以搭配戒指、項鍊、手環的飾品點綴\n\n⏰ 注意事項：商品將預購至6/30後，需等待7-10天時間後出貨\n\n 【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額 \n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n 【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主\"", "prodDescImgs": [], "descImgs": [], "prodImgLength": "", "hasSpecImg": "", "descImgLength": "" },
            { "sku": "LAB24SS-Skirt", "caption": "[選物] CARRYON LAB Skirt 美式復古線條 長裙", "spec": "S-L", "specImg": "", "buyLink": "https://forms.gle/9Avux45YtuCqMJnP9", "price": 880, "specialOffer": null, "inStock": true, "image": "", "series": "24SSLAB 2nd Release", "fittingDesc": [["Female", "Height：166cm", "Weight：46kg", "Size：M", ""], ["Female", "Height：160cm", "Weight：47kg", "Size：S", ""]], "desc": "[選物] CARRYON LAB Skirt 美式復古線條 長裙\n\n價格：$880\n尺寸：S、M、L \n\n長裙是一年四季超百搭單品\n簡單的線條設計\n搭配透氣輕便的材質\n適合夏季穿搭☀️\n\n也有鬆緊帶設計能夠調節裙子寬度\n兩側有口袋使用時十分方便\n\n⏰ 注意事項：商品將預購至6/30後，需等待7-10天時間後出貨\n\n 【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額 \n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n 【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主\"", "prodDescImgs": [], "descImgs": [], "prodImgLength": 2, "hasSpecImg": 1, "descImgLength": 4 },
            { "sku": "LAB24SS-BaggyShort-1", "caption": "[選物] CARRYON LAB  Baggy Short  復古水洗短褲 藍色", "spec": "S-L", "specImg": "", "buyLink": "https://forms.gle/9Avux45YtuCqMJnP9", "price": 880, "specialOffer": null, "inStock": true, "image": "", "series": "24SSLAB 2nd Release", "fittingDesc": [["Female", "Height：166cm", "Weight：46kg", "Size：M", ""], ["Female", "Height：160cm", "Weight：47kg", "Size：S", ""], ["Female", "Height：159cm", "Weight：44kg", "Size：S", ""]], "desc": "[選物] CARRYON LAB  Baggy Short  復古水洗短褲 藍色\n\n價格：$880\n尺寸：S、M、L\n\nCARRYON LAB嚴選最流行的復古水洗短褲 \n\n2024年大家都在穿\n幾乎可以搭配任何上衣\n\n簡約率性的穿搭提升質感\n版型寬鬆俐落\n\n⏰ 注意事項：商品將預購至6/30後，需等待7-10天時間後出貨\n\n 【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額 \n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n 【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主\"", "prodDescImgs": [], "descImgs": [], "prodImgLength": 4, "hasSpecImg": 1, "descImgLength": 4 },
            { "sku": "LAB24SS-BaggyShort-2", "caption": "[選物] CARRYON LAB  Baggy Short  復古水洗短褲 水洗藍", "spec": "S-L", "specImg": "", "buyLink": "https://forms.gle/9Avux45YtuCqMJnP9", "price": 880, "specialOffer": null, "inStock": true, "image": "", "series": "24SSLAB 2nd Release", "fittingDesc": [["Female", "Height：166cm", "Weight：46kg", "Size：M", ""], ["Female", "Height：160cm", "Weight：47kg", "Size：S", ""], ["Female", "Height：159cm", "Weight：44kg", "Size：S", ""]], "desc": "[選物] CARRYON LAB  Baggy Short  復古水洗短褲 藍色\n\n價格：$880\n尺寸：S、M、L\n\nCARRYON LAB嚴選最流行的復古水洗短褲 \n\n2024年大家都在穿\n幾乎可以搭配任何上衣\n\n簡約率性的穿搭提升質感\n版型寬鬆俐落\n\n⏰ 注意事項：商品將預購至6/30後，需等待7-10天時間後出貨\n\n 【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額 \n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n 【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主\"", "prodDescImgs": [], "descImgs": [], "prodImgLength": 4, "hasSpecImg": 1, "descImgLength": 4 }, { "sku": "LAB24SS-ring-1", "caption": "[選物] CARRYON LAB 24SS Ring 可調節 彩色花朵戒指", "spec": "O/S", "specImg": "", "buyLink": "https://forms.gle/9Avux45YtuCqMJnP9", "price": 280, "specialOffer": null, "inStock": true, "image": "", "series": "24SSLAB 2nd Release", "fittingDesc": [], "desc": "[選物] CARRYON LAB 24SS Ring 可調節 彩色花朵戒指\n\n價格：$280\n樣式：彩色小花/趣味星星\n\n⏰ 注意事項：商品將預購至6/30後，需等待7-10天時間後出貨\n\n 【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額 \n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n 【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主\"", "prodDescImgs": [], "descImgs": [], "prodImgLength": 3, "hasSpecImg": 0, "descImgLength": 2 }, { "sku": "LAB24SS-ring-2", "caption": "[選物] CARRYON LAB 24SS Ring 可調節 愛心寶石戒指", "spec": "O/S", "specImg": "", "buyLink": "https://forms.gle/9Avux45YtuCqMJnP9", "price": 320, "specialOffer": null, "inStock": true, "image": "", "series": "24SSLAB 2nd Release", "fittingDesc": [], "desc": "[選物] CARRYON LAB 24SS Ring 可調節 愛心寶石戒指\n\n價格：$320\n樣式：紫色寶石/粉色寶石/黃色寶石/藍色寶石\n\n⏰ 注意事項：商品將預購至6/30後，需等待7-10天時間後出貨\n\n 【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額 \n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n 【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主\"", "prodDescImgs": [], "descImgs": [], "prodImgLength": 2, "hasSpecImg": 0, "descImgLength": 2 }]
    },
    {
        source: 'aws',
        name: 'CARRYON LAB 24SS',
        subTitle: '',
        list: [
            { "sku": "LAB24SSSocks", "caption": "CARRYON 24SS Logo Socks 電繡 毛巾底襪子", "spec": "O/S", "specImg": "", "buyLink": "https://forms.gle/ZECk3JV5QvguEpbs5", "price": 280, "specialOffer": null, "inStock": true, "image": "", "series": "24SSLAB", "fittingDesc": [], "desc": "CARRYON 24SS Logo Socks 電繡 毛巾底長襪\n\n▲ 價格：$280\n▲ 配色：黑色、白色\n▲ 尺寸: 中筒、高筒\n\n穿上 CARRYON 24SS Logo Socks\n感受電繡的優雅與毛巾底的柔軟舒適！\n\n這不僅是一雙襪子，更是風格的象徵\n每一步都是對自我的肯定。\n\n無論你是在日常生活中還是在派對上\n它都將成為你的時尚亮點。\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodDescImgs": [], "descImgs": [], "prodImgLength": 2, "hasSpecImg": 0, "descImgLength": 0 },
            { "sku": "24SSBag-BK", "caption": "CARRYON 24SS Shoulder Bag Logo 羽絨 雲朵包 側背包 黑色", "spec": "O/S", "specImg": "", "buyLink": "https://forms.gle/ZECk3JV5QvguEpbs5", "price": 1180, "specialOffer": null, "inStock": true, "image": "", "series": "24SSLAB", "fittingDesc": [], "desc": "CARRYON 24SS Shoulder Bag Logo羽絨休閒側背包\n\n🔺此款需預購等待約7-10天，請理解後下單，感謝\n\n👉價格：$1180\n👉 配色：黑色、米黃、卡其\n\n融合簡約與實用的完美結合\n不僅擁有獨特的羽絨材質\n更展現了CARRYON 24SS的經典Logo設計\n\n能放下15寸筆電及日常小物\n不論是在城市街頭還是郊外都方便使用\n\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodDescImgs": [], "descImgs": [], "prodImgLength": 3, "hasSpecImg": 1, "descImgLength": 4 },
            { "sku": "24SSBag-KA", "caption": "CARRYON 24SS Shoulder Bag Logo 羽絨 雲朵包 側背包 卡其", "spec": "O/S", "specImg": "", "buyLink": "https://forms.gle/ZECk3JV5QvguEpbs5", "price": 1180, "specialOffer": null, "inStock": true, "image": "", "series": "24SSLAB", "fittingDesc": [], "desc": "CARRYON 24SS Shoulder Bag Logo羽絨休閒側背包\n\n🔺此款需預購等待約7-10天，請理解後下單，感謝\n\n👉價格：$1180\n👉 配色：黑色、米黃、卡其\n\n融合簡約與實用的完美結合\n不僅擁有獨特的羽絨材質\n更展現了CARRYON 24SS的經典Logo設計\n\n能放下15寸筆電及日常小物\n不論是在城市街頭還是郊外都方便使用\n\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodDescImgs": [], "descImgs": [], "prodImgLength": 3, "hasSpecImg": 1, "descImgLength": 4 },
            { "sku": "24SSBag-WH", "caption": "CARRYON 24SS Shoulder Bag Logo 羽絨 雲朵包 側背包 米黃", "spec": "O/S", "specImg": "", "buyLink": "https://forms.gle/ZECk3JV5QvguEpbs5", "price": 1180, "specialOffer": null, "inStock": true, "image": "", "series": "24SSLAB", "fittingDesc": [], "desc": "CARRYON 24SS Shoulder Bag Logo羽絨休閒側背包\n\n🔺此款需預購等待約7-10天，請理解後下單，感謝\n\n👉價格：$1180\n👉 配色：黑色、米黃、卡其\n\n融合簡約與實用的完美結合\n不僅擁有獨特的羽絨材質\n更展現了CARRYON 24SS的經典Logo設計\n\n能放下15寸筆電及日常小物\n不論是在城市街頭還是郊外都方便使用\n\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodDescImgs": [], "descImgs": [], "prodImgLength": 2, "hasSpecImg": 1, "descImgLength": 4 },
            { "sku": "24SSPants-GN", "caption": "CARRYON LAB 24SS Cargo Pants 美式復古工裝褲 寬褲管 綠色", "spec": "S-L", "specImg": "", "buyLink": "https://forms.gle/ZECk3JV5QvguEpbs5", "price": 1380, "specialOffer": null, "inStock": true, "image": "", "series": "24SSLAB", "fittingDesc": [], "desc": "CARRYON LAB 24SS Cargo Pants 美式復古工裝褲 寬褲管 軍綠\n\n🔺此款需預購等待約7-10天，請理解後下單，感謝\n\n👉價格：$1,380\n👉尺寸：S、M、L\n\n除了自創品牌\n團隊特別開發CARRYON LAB\n專為男孩女孩挑選最適合你們的衣物\n\n融合美式復古風格與實用功能\n實用的多功能口袋設計\n\n能輕易放入日常小物\n不論什麼穿搭風格都能輕鬆應對\n\n若褲長太長也有抽繩可以調整\n\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodDescImgs": [], "descImgs": [], "prodImgLength": 3, "hasSpecImg": 1, "descImgLength": 4 },
            { "sku": "24SSJeans-BK", "caption": "CARRYON LAB 24SS Washed Jeans 美式復古水洗牛仔褲", "spec": "S-L", "specImg": "", "buyLink": "https://forms.gle/ZECk3JV5QvguEpbs5", "price": 1280, "specialOffer": null, "inStock": true, "image": "", "series": "24SSLAB", "fittingDesc": [], "desc": "CARRYON LAB 24SS Washed Jeans 美式復古水洗牛仔褲\n\n🔺此款需預購等待約7-10天，請理解後下單，感謝\n\n👉價格：$1,280\n👉尺寸：S、M、L\n\n除了自創品牌\n團隊特別開發CARRYON LAB\n專為男孩女孩挑選最適合你們的衣物\n\n近期最流行的水洗寬褲管牛仔褲來囉！\n\n融合了美式復古風格和現代設計\n經典的牛仔布料，與精心設計的剪裁結合\n營造出獨特風格感受\n\n日常休閒搭配都能輕易上手\n絕對好搭配\n\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodDescImgs": [], "descImgs": [], "prodImgLength": 3, "hasSpecImg": 1, "descImgLength": 4 },
            { "sku": "24SSStorage", "caption": "CARRYON LAB 24SS Storage Box 牛仔布 心型飾品收納盒", "spec": "O/S", "specImg": "", "buyLink": "https://forms.gle/ZECk3JV5QvguEpbs5", "price": 380, "specialOffer": null, "inStock": true, "image": "", "series": "24SSLAB", "fittingDesc": [], "desc": "CARRYON LAB 24SS Storage Box 牛仔布 心型飾品收納盒\n\n🔺此款需預購等待約7-10天，請理解後下單，感謝\n\n👉價格：$1,280\n👉配色：藍色、粉色\n\n為你的珠寶和小飾品尋找一個家\n超可愛牛仔心型飾品收納盒推薦給你\n\n可以根據需要擺放各種小飾品\n保持整齊有序\n飾品再也不會不見！\n\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodDescImgs": [], "descImgs": [], "prodImgLength": 3, "hasSpecImg": 0, "descImgLength": 0 }
        ]
    },
    {
        source: 'aws',
        name: 'CARRYON 24SS',
        subTitle: '',
        list: [
            {
                "sku": "SS24T01-BK",
                "caption": "「預購9折」CARRYON 24SS Logo Waffle Coat 電繡 華夫格 薄款 開衫外套 黑色",
                "spec": "L-XXL",
                "specImg": "",
                "buyLink": "https://forms.gle/C1K2V3aUcS3SpuAMA",
                "price": 1380,
                "specialOffer": 1242,
                "inStock": false,
                "image": "",
                "series": "24SS",
                "fittingDesc": [
                    ["Female", "Height：161cm", "Weight：41kg", "Size：L", "合適"],
                    ["Male", "Height：173cm", "Weight：57kg", "Size：XL", "合適"],
                ],
                "desc": `
                CARRYON 24SS Logo Waffle Coat 電繡 華夫格 薄款 開衫外套

▲ 配色：黑色、淺灰
▲ 尺寸: L-XXL

首次推出華夫格開衫外套，選用較薄的材質

能夠適應日夜溫差的天氣！

大多由純棉製成，整體柔軟舒適、輕盈自然

置入電繡Logo，簡單的設計也能穿出質感

整體俐落不拖泥帶水

【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額

【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主

【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主
                `,
                "prodDescImgs": [],
                "descImgs": [],
                "prodImgLength": 4,
                "hasSpecImg": 1,
                "descImgLength": 4,
            },
            {
                "sku": "SS24T01-GY",
                "caption": "「預購9折」CARRYON 24SS Logo Waffle Coat 電繡 華夫格 薄款 開衫外套 灰色",
                "spec": "L-XXL",
                "specImg": "",
                "buyLink": "https://forms.gle/C1K2V3aUcS3SpuAMA",
                "price": 1380,
                "specialOffer": 1242,
                "inStock": false,
                "image": "",
                "series": "24SS",
                "fittingDesc": [
                    ["Female", "Height：161cm", "Weight：41kg", "Size：L", "合適"],
                    ["Male", "Height：173cm", "Weight：57kg", "Size：XL", "合適"],
                ],
                "desc": `
                CARRYON 24SS Logo Waffle Coat 電繡 華夫格 薄款 開衫外套

▲ 配色：黑色、淺灰
▲ 尺寸: L-XXL

首次推出華夫格開衫外套，選用較薄的材質

能夠適應日夜溫差的天氣！

大多由純棉製成，整體柔軟舒適、輕盈自然

置入電繡Logo，簡單的設計也能穿出質感

整體俐落不拖泥帶水

【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額

【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主

【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主
                `,
                "prodDescImgs": [],
                "descImgs": [],
                "prodImgLength": 5,
                "hasSpecImg": 1,
                "descImgLength": 4,
            },
            {
                "sku": "SS24T02",
                "caption": "「預購9折」CARRYON 24SS Logo Knit 2Way Beanie 電繡 遮耳飛行毛帽",
                "spec": "O/S",
                "specImg": "",
                "buyLink": "https://forms.gle/C1K2V3aUcS3SpuAMA",
                "price": 1080,
                "specialOffer": 972,
                "inStock": false,
                "image": "",
                "series": "24SS",
                "fittingDesc": [
                    ["Female", "Height：161cm", "Weight：41kg", "Size：L", "合適"],
                    ["Male", "Height：173cm", "Weight：57kg", "Size：XL", "合適"],
                ],
                "desc": `
                CARRYON 24SS Logo Knit 2Way Beanie 電繡 遮耳飛行毛帽

▲ 配色：黑色、深藍、酒紅、米色

採用 2WAY 設計
能夠擁有兩種造型，像飛行帽一樣
可以將耳套抬起來繫緊！

飛行帽造型也是很多人愛不釋手
戴上保暖顯臉小！超適合日常穿搭。

【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額

【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主

【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主
                `,
                "prodDescImgs": [],
                "descImgs": [],
                "prodImgLength": 2,
                "hasSpecImg": 0,
                "descImgLength": 4,
            },
        ]
    },
    {
        source: 'aws',
        name: 'CARRYON 23FW',
        subTitle: '',
        list: [
            {
                "sku": "FW23T01-BK", "caption": "CARRYON 23FW Never Miss a Beat Crewneck 重磅 棉大學T 黑色", "spec": "L-XXL", "specImg": "",
                "buyLink": "https://docs.google.com/forms/d/e/1FAIpQLScDpyTSjnM7CBv6EGQtf5jWjYXsGre-4yKQpa1jaq15BVpuaw/viewform",
                "price": 1580, "specialOffer": null, "inStock": false, "image": "", "series": "23FW",
                "fittingDesc": [
                    ["Female", "Height：159cm", "Weight：44kg", "Size：XL", "寬鬆"],
                    ["Female", "Height：161cm", "Weight：41kg", "Size：L", "合適"],
                    ["Male", "Height：173cm", "Weight：57kg", "Size：L", "合適"],
                ],
                "desc": "CARRYON 23FW Never Miss a Beat Crewneck 重磅 棉大學T 黑色 \n\n▲ 配色：黑色、灰綠\n▲ 尺寸：L-XXL\n\n為了讓整體穿搭更加挺直\n選用400G重磅布料\n\n紮實的重磅毛圈布\n具有厚實的手感與柔軟蓬鬆度\n\n親膚感十足，穿起來舒適\noversize穿搭推薦這款！\n\n理念將 Never Miss a Beat 置入背後\n設計成塗鴉字體\n轉換為不放棄的態度\n不錯過任何機會，堅定的向前。\n\nMade In Taiwan\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主",
                "prodDescImgs": [], "descImgs": [],
                "prodImgLength": 4,
                "hasSpecImg": 1,
                "descImgLength": 5,
            },
            {
                "sku": "FW23T01-GR", "caption": "CARRYON 23FW Never Miss a Beat Crewneck 重磅 棉大學T 灰綠", "spec": "L-XXL", "specImg": "",
                "buyLink": "https://docs.google.com/forms/d/e/1FAIpQLScDpyTSjnM7CBv6EGQtf5jWjYXsGre-4yKQpa1jaq15BVpuaw/viewform", "price": 1580, "specialOffer": null, "inStock": true, "image": "", "series": "23FW",
                "fittingDesc": [["Female", "Height：159cm", "Weight：44kg", "Size：XL", "寬鬆"], ["Female", "Height：161cm", "Weight：41kg", "Size：L", "合適"], ["Male", "Height：173cm", "Weight：57kg", "Size：L", "合適"]], "desc": "CARRYON 23FW Never Miss a Beat Crewneck 重磅 棉大學T 灰綠\n\n▲ 配色：黑色、灰綠\n▲ 尺寸：L-XXL\n\n為了讓整體穿搭更加挺直\n選用400G重磅布料\n\n紮實的重磅毛圈布\n具有厚實的手感與柔軟蓬鬆度\n\n親膚感十足，穿起來舒適\noversize穿搭推薦這款！\n\n理念將 Never Miss a Beat 置入背後\n設計成塗鴉字體\n轉換為不放棄的態度\n不錯過任何機會，堅定的向前。\n\nMade In Taiwan\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodDescImgs": [], "descImgs": [],
                "prodImgLength": 3,
                "hasSpecImg": 1,
                "descImgLength": 5,
            },
            {
                "sku": "FW23T02-BK", "caption": "CARRYON 23FW Never Miss a Beat Sweatpants 重磅 棉長褲 黑色", "spec": "M-XL", "specImg": "",
                "buyLink": "https://docs.google.com/forms/d/e/1FAIpQLScDpyTSjnM7CBv6EGQtf5jWjYXsGre-4yKQpa1jaq15BVpuaw/viewform", "price": 1580, "specialOffer": null, "inStock": true, "image": "", "series": "23FW",
                "fittingDesc": [["Female", "Height：159cm", "Weight：44kg", "Size：M", "寬鬆"], ["Male", "Height：173cm", "Weight：57kg", "Size：L", "寬鬆"]], "desc": "CARRYON 23FW Never Miss a Beat Sweatpants 重磅 棉長褲 黑色\n\n▲ 配色：黑色、灰綠\n▲ 尺寸：M-XL\n\n選用400G重磅布料\n紮實的重磅毛圈布\n具有厚實的手感與柔軟蓬鬆度\n\n棉褲是近年流行的時裝單品之一\nOne Tone 穿搭法更是趨勢\n\n置入品牌Logo\n簡單的設計非常易襯易穿\n是入手棉褲的好選擇！\n左右側則有口袋，及背面一個口袋\n設置長抽繩調整腰圍。\n\nMade In Taiwan\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodDescImgs": [], "descImgs": [],
                "prodImgLength": 4,
                "hasSpecImg": 1,
                "descImgLength": 4,
            },
            {
                "sku": "FW23T02-GR", "caption": "CARRYON 23FW Never Miss a Beat Sweatpants 重磅 棉長褲 灰綠", "spec": "M-XL", "specImg": "",
                "buyLink": "https://docs.google.com/forms/d/e/1FAIpQLScDpyTSjnM7CBv6EGQtf5jWjYXsGre-4yKQpa1jaq15BVpuaw/viewform", "price": 1580, "specialOffer": null, "inStock": true, "image": "", "series": "23FW",
                "fittingDesc": [["Female", "Height：159cm", "Weight：44kg", "Size：M", "寬鬆"], ["Male", "Height：173cm", "Weight：57kg", "Size：L", "寬鬆"]], "desc": "CARRYON 23FW Never Miss a Beat Sweatpants 重磅 棉長褲 灰綠\n\n▲ 配色：黑色、灰綠\n▲ 尺寸：M-XL\n\n選用400G重磅布料\n紮實的重磅毛圈布\n具有厚實的手感與柔軟蓬鬆度\n\n棉褲是近年流行的時裝單品之一\nOne Tone 穿搭法更是趨勢\n\n置入品牌Logo\n簡單的設計非常易襯易穿\n是入手棉褲的好選擇！\n左右側則有口袋，及背面一個口袋\n設置長抽繩調整腰圍。\n\nMade In Taiwan\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodDescImgs": [], "descImgs": [],
                "prodImgLength": 4,
                "hasSpecImg": 1,
                "descImgLength": 4,
            },
            {
                "sku": "FW23T03-BK", "caption": "CARRYON LAB 選物 防水機能多功能衝鋒外套 黑色", "spec": "M-XL", "specImg": "",
                "buyLink": "https://docs.google.com/forms/d/e/1FAIpQLScDpyTSjnM7CBv6EGQtf5jWjYXsGre-4yKQpa1jaq15BVpuaw/viewform", "price": 2480, "specialOffer": null, "inStock": true, "image": "", "series": "23FW",
                "fittingDesc": [["Female", "Height：159cm", "Weight：44kg", "Size：XL", "寬鬆"], ["Female", "Height：161cm", "Weight：41kg", "Size：L", "合適"], ["image length", "Height：商品主圖片數量（幾張）", "Weight：", "Size：", ""]], "desc": "CARRYON LAB 選物 防水機能多功能衝鋒外套 黑色\n\n▲ 配色：黑色、灰色\n▲ 尺寸：M-XL\n\n日常穿搭、戶外活動都適合穿\n經過團隊嚴選出實穿好搭的機能外套\n\n使用穩定的防水布料，能夠達到防潑水效果\n連拉鍊都做防水！細節度滿分\n且耐磨耐用能夠滿足日常生活各種需求\n\n共超過四個口袋，放手機小物都沒問題！\n\n【預購】 此商品為預購，下單後一週，能夠收到貨\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodDescImgs": [], "descImgs": [],
                "prodImgLength": 3,
                "hasSpecImg": 1,
                "descImgLength": 5,
            },
            {
                "sku": "FW23T03-GY", "caption": "CARRYON LAB 選物 防水機能多功能衝鋒外套 灰色", "spec": "M-XL", "specImg": "",
                "buyLink": "https://docs.google.com/forms/d/e/1FAIpQLScDpyTSjnM7CBv6EGQtf5jWjYXsGre-4yKQpa1jaq15BVpuaw/viewform", "price": 2480, "specialOffer": null, "inStock": true, "image": "", "series": "23FW",
                "fittingDesc": [["Female", "Height：159cm", "Weight：44kg", "Size：XL", "寬鬆"], ["Female", "Height：161cm", "Weight：41kg", "Size：L", "合適"], ["image length", "Height：商品主圖片數量（幾張）", "Weight：", "Size：", ""]], "desc": "CARRYON LAB 選物 防水機能多功能衝鋒外套 灰色\n\n▲ 配色：黑色、灰色\n▲ 尺寸：M-XL\n\n日常穿搭、戶外活動都適合穿\n經過團隊嚴選出實穿好搭的機能外套\n\n使用穩定的防水布料，能夠達到防潑水效果\n連拉鍊都做防水！細節度滿分\n且耐磨耐用能夠滿足日常生活各種需求\n\n共超過四個口袋，放手機小物都沒問題！\n\n【預購】 此商品為預購，下單後一週，能夠收到貨\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodDescImgs": [], "descImgs": [],
                "prodImgLength": 4,
                "hasSpecImg": 1,
                "descImgLength": 5,
            },
            {
                "sku": "FW23T04-BK", "caption": "CARRYON 23FW Logo Belt 可拆卸扣頭腰帶 黑色", "spec": "O/S", "specImg": "",
                "buyLink": "https://docs.google.com/forms/d/e/1FAIpQLScDpyTSjnM7CBv6EGQtf5jWjYXsGre-4yKQpa1jaq15BVpuaw/viewform", "price": 680, "specialOffer": null, "inStock": true, "image": "", "series": "23FW",
                "fittingDesc": [], "desc": "CARRYON 23FW Logo Belt 可拆卸扣頭腰帶 黑色\n\n▲ 配色：黑色、鏡面銀\n▲ 尺寸: 長度120cm\n\n升級！升級！\n腰帶採用鏡面金屬及霧面黑配置\n更加有質感，整體輕盈許多\n\n喜歡穿寬鬆的朋友\n都需要一條腰帶\n\n我們以實際需求出發\n使用雷射雕刻技術將 Logo 注入\n\n簡單的設定\n在使用上只要一個步驟就能輕鬆扣緊\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodDescImgs": [], "descImgs": [],
                "prodImgLength": 4,
                "hasSpecImg": 1,
                "descImgLength": 1,
            },
            {
                "sku": "FW23T04-GY", "caption": "CARRYON 23FW Logo Belt 可拆卸扣頭腰帶 鏡面銀", "spec": "O/S", "specImg": "",
                "buyLink": "https://docs.google.com/forms/d/e/1FAIpQLScDpyTSjnM7CBv6EGQtf5jWjYXsGre-4yKQpa1jaq15BVpuaw/viewform", "price": 680, "specialOffer": null, "inStock": true, "image": "", "series": "23FW",
                "fittingDesc": [], "desc": "CARRYON 23FW Logo Belt 可拆卸扣頭腰帶 鏡面銀\n\n▲ 配色：黑色、鏡面銀\n▲ 尺寸: 長度120cm\n\n升級！升級！\n腰帶採用鏡面金屬及霧面黑配置\n更加有質感，整體輕盈許多\n\n喜歡穿寬鬆的朋友\n都需要一條腰帶\n\n我們以實際需求出發\n使用雷射雕刻技術將 Logo 注入\n\n簡單的設定\n在使用上只要一個步驟就能輕鬆扣緊\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodDescImgs": [], "descImgs": [],
                "prodImgLength": 4,
                "hasSpecImg": 1,
                "descImgLength": 3,
            },
            {
                "sku": "FW23T05", "caption": "CARRYON 23FW Never Miss a Beat Bucket Hat 電繡 漁夫帽", "spec": "O/S", "specImg": "",
                "buyLink": "https://docs.google.com/forms/d/e/1FAIpQLScDpyTSjnM7CBv6EGQtf5jWjYXsGre-4yKQpa1jaq15BVpuaw/viewform", "price": 880, "specialOffer": null, "inStock": true, "image": "", "series": "23FW",
                "fittingDesc": [], "desc": "CARRYON 23FW Never Miss a Beat Bucket Hat 電繡 漁夫帽\n\n▲ 配色：黑牛仔、藍牛仔\n\n最不挑臉型的帽子！\nCARRYON 再度推出漁夫帽\n\n選用牛仔布料，並用電繡工法\n將 Never Miss a Beat 理念置入\n\n正方面皆有Logo設計\n\n此款帽沿較寬，帶來不同的感覺\n更添加率性街頭風格\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodDescImgs": [], "descImgs": [],
                "prodImgLength": 4,
                "hasSpecImg": 1,
                "descImgLength": 5,
            }]
    },
    //     {
    //         source: 'aws',
    //         name: '2023 LUCKY BAG',
    //         subTitle: '',
    //         list: [
    //             {
    //                 "sku": "CARRYON 2023 LUCKY BAG-S",
    //                 "caption": "CARRYON 雙11限定【 LUCKY BAG 】超值福袋 (小)",
    //                 "spec": "O/S",
    //                 "specImg": "",
    //                 "buyLink": "https://forms.gle/Gato7jvnNpCRdgya8",
    //                 "price": 1111,
    //                 "specialOffer": null,
    //                 "inStock": false,
    //                 "image": "",
    //                 "series": "2023 LUCKY BAG",
    //                 "fittingDesc": [],
    //                 "desc": `🔺CARRYON 雙11限定【 LUCKY BAG 】超值福袋 🔺

    // 💡販賣時間：11/10~11/19 ( 數量有限 )

    // 💡價格：$1111、$2222

    // 錯過等明年，超值福袋等你來搶購，全年最低價就是這時候，直接通通五折起，全部包進去！


    // ⚡️$1111 內容物：一件服飾+配件

    // ⚡️$2222內容物：一件服飾+一件長褲

    // 【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額

    // `,
    //                 "prodImgLength": 1,
    //                 "hasSpecImg": 0,
    //                 "descImgLength": 2,
    //             },
    //             {
    //                 "sku": "CARRYON 2023 LUCKY BAG-M",
    //                 "caption": "CARRYON 雙11限定【 LUCKY BAG 】超值福袋 (大)",
    //                 "spec": "O/S",
    //                 "specImg": "",
    //                 "buyLink": "https://forms.gle/Gato7jvnNpCRdgya8",
    //                 "price": 2222,
    //                 "specialOffer": null,
    //                 "inStock": false,
    //                 "image": "",
    //                 "series": "2023 LUCKY BAG",
    //                 "fittingDesc": [],
    //                 "desc": `🔺CARRYON 雙11限定【 LUCKY BAG 】超值福袋 🔺

    // 💡販賣時間：11/10~11/19 ( 數量有限 )

    // 💡價格：$1111、$2222

    // 錯過等明年，超值福袋等你來搶購，全年最低價就是這時候，直接通通五折起，全部包進去！


    // ⚡️$1111 內容物：一件服飾+配件

    // ⚡️$2222內容物：一件服飾+一件長褲

    // 【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額

    // `,
    //                 "prodImgLength": 1,
    //                 "hasSpecImg": 0,
    //                 "descImgLength": 2,
    //             },
    //         ]
    //     },
    //     {
    //         source: 'aws',
    //         name: '23SS logo accessories',
    //         subTitle: '',
    //         list: [
    //             {
    //                 "sku": "23SS logoacc-1",
    //                 "caption": "CARRYON 23SS Logo Necklace 吊墜鈦鋼項鍊",
    //                 "spec": "O/S",
    //                 "specImg": "",
    //                 "buyLink": "https://forms.gle/R42kiodvUo4WAfvr9",
    //                 "price": 780,
    //                 "specialOffer": null,
    //                 "inStock": false,
    //                 "image": "",
    //                 "series": "23SS logo accessories",
    //                 "fittingDesc": [],
    //                 "desc": `
    //                 CARRYON 23SS Logo Necklace 吊墜鈦鋼項鍊 

    // ▲ 長度：60cm
    // ▲項鍊規格：麻花鏈子、O字鏈

    // 此為鈦鋼製，耐磨堅硬
    // 不易氧化褪色，可碰水

    // Made In Taiwan

    // 【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額

    // 【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主

    // 【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主
    // `,
    //                 "prodImgLength": 1,
    //                 "hasSpecImg": 0,
    //                 "descImgLength": 4,
    //             },
    //             {
    //                 "sku": "23SS logoacc-2",
    //                 "caption": "CARRYON 23SS Logo Earrings 耳扣式耳環",
    //                 "spec": "O/S",
    //                 "specImg": "",
    //                 "buyLink": "https://forms.gle/R42kiodvUo4WAfvr9",
    //                 "price": 480,
    //                 "specialOffer": null,
    //                 "inStock": true,
    //                 "image": "",
    //                 "series": "23SS logo accessories",
    //                 "fittingDesc": [],
    //                 "desc": `
    //                 CARRYON 23SS Logo Necklace 吊墜鈦鋼項鍊 

    // ▲ 長度：4cm

    // 此為鈦鋼製，耐磨堅硬
    // 不易氧化褪色，可碰水

    // Made In Taiwan

    // 【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額

    // 【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主

    // 【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主
    // `,
    //                 "prodImgLength": 1,
    //                 "hasSpecImg": 0,
    //                 "descImgLength": 3,
    //             },
    //         ]
    //     },
    {
        source: 'aws',
        name: 'CARRYON 23SS September',
        subTitle: '',
        list: [
            {
                "sku": "CARRYON23SSWashedTee-GN",
                "caption": "CARRYON 23SS Washed CD 光碟 Logo Tee 短T 灰綠", "spec": "M-XXL", "specImg": "",
                "buyLink": "https://forms.gle/2wLUiWkubD6k5qbU9", "price": 1180, "specialOffer": null, "inStock": true, "image": "", "series": "23SS September", "fittingDesc": [["Female", "Height：159cm", "Weight：44kg", "Size：M"], ["Female", "Height：166cm", "Weight：46kg", "Size：L"], ["Male", "Height：183cm", "Weight：67kg", "Size：XL"]], "desc": "CARRYON 23SS Washed CD 光碟 Logo Tee 短T \n\n▲ 配色：灰綠、深灰、駝色\n▲ 尺寸：M、L、XL、XXL\n\n在生活中\n音樂、跳舞與我們息息相關\n已經深深印烙在心中\n成為缺一不可的夥伴\n\n設計中的圓形CD\n代表對於音樂的喜愛與執著\n背後不同人型的動作\n意想成跳舞、滑板等\n\n本季版型再度更新！\n採用水洗布料，跳脫以往黑白設計\n寬鬆落肩剪裁，整體更加有型\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodImgLength": 7, "descImgLength": 6, "hasSpecImg": true
            },
            {
                "sku": "CARRYON23SSWashedTee-GY",
                "caption": "CARRYON 23SS Washed CD 光碟 Logo Tee 短T 深灰", "spec": "M-XXL", "specImg": "",
                "buyLink": "https://forms.gle/2wLUiWkubD6k5qbU9", "price": 1180, "specialOffer": null, "inStock": false, "image": "", "series": "23SS September", "fittingDesc": [["Female", "Height：159cm", "Weight：44kg", "Size：M"], ["Female", "Height：166cm", "Weight：46kg", "Size：L"], ["Male", "Height：183cm", "Weight：67kg", "Size：XL"]], "desc": "CARRYON 23SS Washed CD 光碟 Logo Tee 短T \n\n▲ 配色：灰綠、深灰、駝色\n▲ 尺寸：M、L、XL、XXL\n\n在生活中\n音樂、跳舞與我們息息相關\n已經深深印烙在心中\n成為缺一不可的夥伴\n\n設計中的圓形CD\n代表對於音樂的喜愛與執著\n背後不同人型的動作\n意想成跳舞、滑板等\n\n本季版型再度更新！\n採用水洗布料，跳脫以往黑白設計\n寬鬆落肩剪裁，整體更加有型\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodImgLength": 7, "descImgLength": 6, "hasSpecImg": true
            },
            {
                "sku": "CARRYON23SSWashedTee-BE",
                "caption": "CARRYON 23SS Washed CD 光碟 Logo Tee 短T 駝色", "spec": "M-XXL", "specImg": "",
                "buyLink": "https://forms.gle/2wLUiWkubD6k5qbU9", "price": 1180, "specialOffer": null, "inStock": true, "image": "", "series": "23SS September", "fittingDesc": [["Female", "Height：159cm", "Weight：44kg", "Size：M"], ["Female", "Height：166cm", "Weight：46kg", "Size：L"], ["Male", "Height：183cm", "Weight：67kg", "Size：XL"]], "desc": "CARRYON 23SS Washed CD 光碟 Logo Tee 短T \n\n▲ 配色：灰綠、深灰、駝色\n▲ 尺寸：M、L、XL、XXL\n\n在生活中\n音樂、跳舞與我們息息相關\n已經深深印烙在心中\n成為缺一不可的夥伴\n\n設計中的圓形CD\n代表對於音樂的喜愛與執著\n背後不同人型的動作\n意想成跳舞、滑板等\n\n本季版型再度更新！\n採用水洗布料，跳脫以往黑白設計\n寬鬆落肩剪裁，整體更加有型\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodImgLength": 6, "descImgLength": 6, "hasSpecImg": true
            },
            {
                "sku": "CARRYON23SSRunnerTee-BY",
                "caption": "CARRYON 23SS Runner Tee 跑跑人厚磅 短T 炭灰", "spec": "M-XXL", "specImg": "",
                "buyLink": "https://forms.gle/2wLUiWkubD6k5qbU9", "price": 1280, "specialOffer": null, "inStock": false, "image": "", "series": "23SS September", "fittingDesc": [["Female", "Height：161cm", "Weight：44kg", "Size：XL"], ["Female", "Height：176cm", "Weight：68kg", "Size：L"], ["Male", "Height：174cm", "Weight：63kg", "Size：M"]], "desc": "CARRYON 23SS Runner Tee 跑跑人厚磅 短T\n\n▲ 配色：炭灰、藏藍、灰駝\n▲ 尺寸：M、L、XL、XXL\n\nCARRYON 全新吉祥物-跑跑人\n帶出品牌理念\n\nYOU TO CARRYON FOR YOU\n\n為了自己堅持，成為心中想要的樣子\n\n象徵堅持向前\n充滿毅力、活潑的形象\n\n泡泡字體Logo帶出可愛氛圍\n穿搭搭配沒煩惱\n\n採用厚磅材質\n版型挺、穿起來不易有皺摺\n此版型更大，需注意建議小一號購買\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodImgLength": 5, "descImgLength": 6, "hasSpecImg": true
            },
            {
                "sku": "CARRYON23SSRunnerTee-BL",
                "caption": "CARRYON 23SS Runner Tee 跑跑人厚磅 短T 藏藍", "spec": "M-XXL", "specImg": "",
                "buyLink": "https://forms.gle/2wLUiWkubD6k5qbU9", "price": 1280, "specialOffer": null, "inStock": false, "image": "", "series": "23SS September", "fittingDesc": [["Female", "Height：161cm", "Weight：44kg", "Size：XL"], ["Female", "Height：176cm", "Weight：68kg", "Size：L"], ["Male", "Height：174cm", "Weight：63kg", "Size：M"]], "desc": "CARRYON 23SS Runner Tee 跑跑人厚磅 短T\n\n▲ 配色：炭灰、藏藍、灰駝\n▲ 尺寸：M、L、XL、XXL\n\nCARRYON 全新吉祥物-跑跑人\n帶出品牌理念\n\nYOU TO CARRYON FOR YOU\n\n為了自己堅持，成為心中想要的樣子\n\n象徵堅持向前\n充滿毅力、活潑的形象\n\n泡泡字體Logo帶出可愛氛圍\n穿搭搭配沒煩惱\n\n採用厚磅材質\n版型挺、穿起來不易有皺摺\n此版型更大，需注意建議小一號購買\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodImgLength": 5, "descImgLength": 6, "hasSpecImg": true
            },
            {
                "sku": "CARRYON23SSRunnerTee-GB",
                "caption": "CARRYON 23SS Runner Tee 跑跑人厚磅 短T 灰駝色", "spec": "M-XXL", "specImg": "",
                "buyLink": "https://forms.gle/2wLUiWkubD6k5qbU9", "price": 1280, "specialOffer": null, "inStock": true, "image": "", "series": "23SS September", "fittingDesc": [["Female", "Height：161cm", "Weight：44kg", "Size：XL"], ["Female", "Height：176cm", "Weight：68kg", "Size：L"], ["Male", "Height：174cm", "Weight：63kg", "Size：M"]], "desc": "CARRYON 23SS Runner Tee 跑跑人厚磅 短T\n\n▲ 配色：炭灰、藏藍、灰駝\n▲ 尺寸：M、L、XL、XXL\n\nCARRYON 全新吉祥物-跑跑人\n帶出品牌理念\n\nYOU TO CARRYON FOR YOU\n\n為了自己堅持，成為心中想要的樣子\n\n象徵堅持向前\n充滿毅力、活潑的形象\n\n泡泡字體Logo帶出可愛氛圍\n穿搭搭配沒煩惱\n\n採用厚磅材質\n版型挺、穿起來不易有皺摺\n此版型更大，需注意建議小一號購買\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodImgLength": 5, "descImgLength": 6, "hasSpecImg": true
            },
            {
                "sku": "CARRYON23SSNylonpants-BK",
                "caption": "CARRYON 23SS Logo Nylon pants 薄款 尼龍長褲 黑色", "spec": "M-XL", "specImg": "",
                "buyLink": "https://forms.gle/2wLUiWkubD6k5qbU9", "price": 1880, "specialOffer": null, "inStock": true, "image": "", "series": "23SS September", "fittingDesc": [["Female", "Height：159cm", "Weight：44kg", "Size：M"], ["Female", "Height：183cm", "Weight：67kg", "Size：XL"], ["Male", "Height：176cm", "Weight：68kg", "Size：L"]], "desc": "CARRYON 23SS Logo Nylon pants 薄款 尼龍長褲 \n\n▲ 配色：黑色、白色\n▲ 尺寸：Ｍ、L、XL\n\n2023最流行的尼龍長褲\n經過團隊研發\n找到最適合大家穿著的設計款\n\n寬鬆寬管一直都是大家的最愛\n輕薄的材質，對抗炎熱的夏季\n\n背後口袋與先前褲款設計相同\n分別置入CARRYON Logo\n則前方口袋側邊則加入小標細節\n\n不論是穿搭、跳舞、滑板\n都非常適合著用此款長褲\n\n若腰圍太大可以使用腰帶調整\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodImgLength": 7, "descImgLength": 6, "hasSpecImg": true
            },
            {
                "sku": "CARRYON23SSNylonpants-WH",
                "caption": "CARRYON 23SS Logo Nylon pants 薄款 尼龍長褲 灰白", "spec": "M-XL", "specImg": "",
                "buyLink": "https://forms.gle/2wLUiWkubD6k5qbU9", "price": 1880, "specialOffer": null, "inStock": false, "image": "", "series": "23SS September", "fittingDesc": [["Female", "Height：159cm", "Weight：44kg", "Size：M"], ["Female", "Height：183cm", "Weight：67kg", "Size：XL"], ["Male", "Height：176cm", "Weight：68kg", "Size：L"]], "desc": "CARRYON 23SS Logo Nylon pants 薄款 尼龍長褲 \n\n▲ 配色：黑色、白色\n▲ 尺寸：Ｍ、L、XL\n\n2023最流行的尼龍長褲\n經過團隊研發\n找到最適合大家穿著的設計款\n\n寬鬆寬管一直都是大家的最愛\n輕薄的材質，對抗炎熱的夏季\n\n背後口袋與先前褲款設計相同\n分別置入CARRYON Logo\n則前方口袋側邊則加入小標細節\n\n不論是穿搭、跳舞、滑板\n都非常適合著用此款長褲\n\n若腰圍太大可以使用腰帶調整\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodImgLength": 7, "descImgLength": 6, "hasSpecImg": true
            },
            {
                "sku": "CARRYON23SSCampCap-BK",
                "caption": "CARRYON 23SS Logo Camp Cap 抽繩調節 電繡五分割 黑橘", "spec": "O/S", "specImg": "",
                "buyLink": "https://forms.gle/2wLUiWkubD6k5qbU9", "price": 1080, "specialOffer": null, "inStock": false, "image": "", "series": "23SS September", "fittingDesc": [], "desc": "CARRYON 23SS Logo Camp Cap 抽繩調節 電繡五分割\n\n▲ 配色：黑橘、綠白\n▲ 尺寸：O/S\n\n嘻哈人必備的單品\n肯定是五分割莫屬\n\n採用電繡設計置入Logo\n\n這一次選用抽繩調節\n只要一個拉的動作就能輕易調整頭圍\n\n帽子不顯多，喜歡就下單！\n\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodImgLength": 4, "descImgLength": 5, "hasSpecImg": false
            },
            {
                "sku": "CARRYON23SSCampCap-GE",
                "caption": "CARRYON 23SS Logo Camp Cap 抽繩調節 電繡五分割 綠白", "spec": "O/S", "specImg": "",
                "buyLink": "https://forms.gle/2wLUiWkubD6k5qbU9", "price": 1080, "specialOffer": null, "inStock": false, "image": "", "series": "23SS September", "fittingDesc": [], "desc": "CARRYON 23SS Logo Camp Cap 抽繩調節 電繡五分割\n\n▲ 配色：黑橘、綠白\n▲ 尺寸：O/S\n\n嘻哈人必備的單品\n肯定是五分割莫屬\n\n採用電繡設計置入Logo\n\n這一次選用抽繩調節\n只要一個拉的動作就能輕易調整頭圍\n\n帽子不顯多，喜歡就下單！\n\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主", "prodImgLength": 4, "descImgLength": 5, "hasSpecImg": false
            }
        ]
    },
    {
        source: 'aws',
        name: 'CARRYON 23SS LAB',
        subTitle: '',
        list: [
            {
                sku: 'CARRYONLABTEE-GY',
                caption: 'CARRYON LAB 23SS 雀斑愛心人 寬短版上衣 水洗 灰色',
                spec: 'S-M',
                specImg: '',
                buyLink: 'https://forms.gle/AFHCCN61QnpVhrWa9',
                price: 980,
                specialOffer: null,
                inStock: true,
                image: '',
                series: '23SS LAB',
                fittingDesc: [
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：S'],
                    ['Female', 'Height：166cm', 'Weight：46kg', 'Size：M'],
                    ['Female', 'Height：160cm', 'Weight：47kg', 'Size：S'],
                    ['Female', 'Height：161cm', 'Weight：45kg', 'Size：M'],
                ],
                desc: `CARRYON LAB 23SS 雀斑愛心人 寬短版上衣

                ▲ 配色：灰色、紫羅蘭、淺紅
                ▲ 尺寸：S、M
                
                夏日女孩必備單品
                跟以往款式不同
                
                採用寬鬆短版剪裁
                讓整體穿搭更顯俐落帥氣
                搭配繽紛配色及水洗工法更加分
                
                設計上的雀斑愛心人
                提醒每位女孩
                堅強又可愛是妳的專利
                努力生活的同時也記得堅持自己的少女心！
                
                此款衣長較短
                可以穿著運動小可愛搭配
                
                Made In Taiwan
                
                【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額
                【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodImgLength: 4,
                descImgLength: 4,
                hasSpecImg: true
            },
            {
                sku: 'CARRYONLABTEE-PR',
                caption: 'CARRYON LAB 23SS 雀斑愛心人 寬短版上衣 水洗 紫羅蘭',
                spec: 'S-M',
                specImg: '',
                buyLink: 'https://forms.gle/AFHCCN61QnpVhrWa9',
                price: 980,
                specialOffer: null,
                inStock: false,
                image: '',
                series: '23SS LAB',
                fittingDesc: [
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：S'],
                    ['Female', 'Height：166cm', 'Weight：46kg', 'Size：M'],
                    ['Female', 'Height：160cm', 'Weight：47kg', 'Size：S'],
                    ['Female', 'Height：161cm', 'Weight：45kg', 'Size：M'],
                ],
                desc: `CARRYON LAB 23SS 雀斑愛心人 寬短版上衣

                ▲ 配色：灰色、紫羅蘭、淺紅
                ▲ 尺寸：S、M
                
                夏日女孩必備單品
                跟以往款式不同
                
                採用寬鬆短版剪裁
                讓整體穿搭更顯俐落帥氣
                搭配繽紛配色及水洗工法更加分
                
                設計上的雀斑愛心人
                提醒每位女孩
                堅強又可愛是妳的專利
                努力生活的同時也記得堅持自己的少女心！
                
                此款衣長較短
                可以穿著運動小可愛搭配
                
                Made In Taiwan
                
                【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額
                【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodImgLength: 4,
                descImgLength: 4,
                hasSpecImg: true
            },
            {
                sku: 'CARRYONLABTEE-RD',
                caption: 'CARRYON LAB 23SS 雀斑愛心人 寬短版上衣 水洗 淺紅',
                spec: 'S-M',
                specImg: '',
                buyLink: 'https://forms.gle/AFHCCN61QnpVhrWa9',
                price: 980,
                specialOffer: null,
                inStock: true,
                image: '',
                series: '23SS LAB',
                fittingDesc: [
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：S'],
                    ['Female', 'Height：166cm', 'Weight：46kg', 'Size：M'],
                    ['Female', 'Height：160cm', 'Weight：47kg', 'Size：S'],
                    ['Female', 'Height：161cm', 'Weight：45kg', 'Size：M'],
                ],
                desc: `CARRYON LAB 23SS 雀斑愛心人 寬短版上衣

                ▲ 配色：灰色、紫羅蘭、淺紅
                ▲ 尺寸：S、M
                
                夏日女孩必備單品
                跟以往款式不同
                
                採用寬鬆短版剪裁
                讓整體穿搭更顯俐落帥氣
                搭配繽紛配色及水洗工法更加分
                
                設計上的雀斑愛心人
                提醒每位女孩
                堅強又可愛是妳的專利
                努力生活的同時也記得堅持自己的少女心！
                
                此款衣長較短
                可以穿著運動小可愛搭配
                
                Made In Taiwan
                
                【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額
                【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodImgLength: 4,
                descImgLength: 4,
                hasSpecImg: true
            },
            {
                sku: 'CARRYONLABTANK-BK',
                caption: 'CARRYON LAB 23SS 雀斑愛心人 羅紋無袖短版背心  黑色',
                spec: 'L-XL',
                specImg: '',
                buyLink: 'https://forms.gle/AFHCCN61QnpVhrWa9',
                price: 880,
                specialOffer: null,
                inStock: false,
                image: '',
                series: '23SS LAB',
                fittingDesc: [
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：L'],
                    ['Female', 'Height：166cm', 'Weight：46kg', 'Size：XL'],
                    ['Female', 'Height：160cm', 'Weight：47kg', 'Size：L'],
                    ['Female', 'Height：161cm', 'Weight：45kg', 'Size：XL'],
                ],
                desc: `CARRYON LAB 23SS 雀斑愛心人 羅紋無袖短版背心 

                ▲ 配色：黑色、白色
                ▲ 尺寸：L、XL
                
                高溫度，需要來件無袖背心
                穿上直接變身夏季辣妹
                
                使用羅紋布料
                親膚感十足，炎炎夏日也不悶熱
                在搭配上能展現出甜美酷帥風格
                
                設計上的雀斑愛心人
                提醒每位女孩
                堅強又可愛是妳的專利
                努力生活的同時也記得堅持自己的少女心
                
                Made In Taiwan
                
                【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額
                【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodImgLength: 4,
                descImgLength: 4,
                hasSpecImg: true
            },
            {
                sku: 'CARRYONLABTANK-WH',
                caption: 'CARRYON LAB 23SS 雀斑愛心人 羅紋無袖短版背心  白色',
                spec: 'L-XL',
                specImg: '',
                buyLink: 'https://forms.gle/AFHCCN61QnpVhrWa9',
                price: 880,
                specialOffer: null,
                inStock: false,
                image: '',
                series: '23SS LAB',
                fittingDesc: [
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：L'],
                    ['Female', 'Height：166cm', 'Weight：46kg', 'Size：XL'],
                    ['Female', 'Height：160cm', 'Weight：47kg', 'Size：L'],
                    ['Female', 'Height：161cm', 'Weight：45kg', 'Size：XL'],
                ],
                desc: `CARRYON LAB 23SS 雀斑愛心人 羅紋無袖短版背心 

                ▲ 配色：黑色、白色
                ▲ 尺寸：L、XL
                
                高溫度，需要來件無袖背心
                穿上直接變身夏季辣妹
                
                使用羅紋布料
                親膚感十足，炎炎夏日也不悶熱
                在搭配上能展現出甜美酷帥風格
                
                設計上的雀斑愛心人
                提醒每位女孩
                堅強又可愛是妳的專利
                努力生活的同時也記得堅持自己的少女心
                
                Made In Taiwan
                
                【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額
                【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodImgLength: 4,
                descImgLength: 4,
                hasSpecImg: true
            },
            {
                sku: 'CARRYONLABPANTS-GY',
                caption: 'CARRYON LAB 23SS 選物 機能多口袋工裝長褲 深灰',
                spec: 'XS-XL',
                specImg: '',
                buyLink: 'https://forms.gle/AFHCCN61QnpVhrWa9',
                price: 1280,
                specialOffer: null,
                inStock: false,
                image: '',
                series: '23SS LAB',
                fittingDesc: [
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：S'],
                    ['Female', 'Height：166cm', 'Weight：46kg', 'Size：L'],
                    ['Female', 'Height：160cm', 'Weight：47kg', 'Size：M'],
                    ['Female', 'Height：161cm', 'Weight：45kg', 'Size：M'],
                ],
                desc: `CARRYON LAB 23SS 選物 機能多口袋工裝長褲

                ▲ 配色：黑色、深灰、杏色
                ▲ 尺寸：XS、S、M、L、XL
                
                這款穿上直接比例up
                搭配短版上衣絕對無敵！
                
                功能上也很方便
                採用鬆緊腰帶能隨時調節腰圍
                
                共有六種口袋，皆有拉鍊或扣帶
                不用擔心物品掉落，整體機能感更升級
                
                Made In Taiwan
                
                【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額
                
                【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                
                【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodImgLength: 5,
                descImgLength: 5,
                hasSpecImg: true
            },
            {
                sku: 'CARRYONLABPANTS-AP',
                caption: 'CARRYON LAB 23SS 選物 機能多口袋工裝長褲 杏色',
                spec: 'XS-XL',
                specImg: '',
                buyLink: 'https://forms.gle/AFHCCN61QnpVhrWa9',
                price: 1280,
                specialOffer: null,
                inStock: false,
                image: '',
                series: '23SS LAB',
                fittingDesc: [
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：S'],
                    ['Female', 'Height：166cm', 'Weight：46kg', 'Size：L'],
                    ['Female', 'Height：160cm', 'Weight：47kg', 'Size：M'],
                    ['Female', 'Height：161cm', 'Weight：45kg', 'Size：M'],
                ],
                desc: `CARRYON LAB 23SS 選物 機能多口袋工裝長褲

                ▲ 配色：黑色、深灰、杏色
                ▲ 尺寸：XS、S、M、L、XL
                
                這款穿上直接比例up
                搭配短版上衣絕對無敵！
                
                功能上也很方便
                採用鬆緊腰帶能隨時調節腰圍
                
                共有六種口袋，皆有拉鍊或扣帶
                不用擔心物品掉落，整體機能感更升級
                
                Made In Taiwan
                
                【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額
                
                【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                
                【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodImgLength: 5,
                descImgLength: 5,
                hasSpecImg: true
            },
            {
                sku: 'CARRYONLABPANTS-BK',
                caption: 'CARRYON LAB 23SS 選物 機能多口袋工裝長褲 黑色',
                spec: 'XS-XL',
                specImg: '',
                buyLink: 'https://forms.gle/AFHCCN61QnpVhrWa9',
                price: 1280,
                specialOffer: null,
                inStock: false,
                image: '',
                series: '23SS LAB',
                fittingDesc: [
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：S'],
                    ['Female', 'Height：166cm', 'Weight：46kg', 'Size：L'],
                    ['Female', 'Height：160cm', 'Weight：47kg', 'Size：M'],
                    ['Female', 'Height：161cm', 'Weight：45kg', 'Size：M'],
                ],
                desc: `CARRYON LAB 23SS 選物 機能多口袋工裝長褲

                ▲ 配色：黑色、深灰、杏色
                ▲ 尺寸：XS、S、M、L、XL
                
                這款穿上直接比例up
                搭配短版上衣絕對無敵！
                
                功能上也很方便
                採用鬆緊腰帶能隨時調節腰圍
                
                共有六種口袋，皆有拉鍊或扣帶
                不用擔心物品掉落，整體機能感更升級
                
                Made In Taiwan
                
                【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額
                
                【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                
                【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodImgLength: 5,
                descImgLength: 5,
                hasSpecImg: true
            },
        ],
    },
    {
        source: 'aws',
        name: 'CARRYON 23SS',
        subTitle: '',
        list: [
            {
                sku: '23SSjeans-BK',
                caption: 'CARRYON 23SS Denim jeans 口袋寬版水洗牛仔褲 黑色',
                spec: 'M-2XL',
                specImg: '',
                buyLink: 'https://forms.gle/Y9x8WLqmhefo17XW8',
                price: 1580,
                specialOffer: null,
                inStock: false,
                image: '',
                series: '23SS',
                fittingDesc: [
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：M', '寬鬆'],
                    ['Female', 'Height：161cm', 'Weight：41kg', 'Size：L', '寬鬆'],
                    ['Male', 'Height：174cm', 'Weight：63kg', 'Size：XL', '寬鬆'],
                    ['Male', 'Height：180cm', 'Weight：61kg', 'Size：2XL', '寬鬆'],
                    ['Male', 'Height：180cm', 'Weight：64kg', 'Size：2XL', '寬鬆'],
                ],
                desc: 'CARRYON 23SS Logo Denim jeans口袋寬版水洗牛仔褲\n\n▲ 配色：黑色、藍色\n▲尺寸：M-2XL\n\n特別選用水洗面料，與以往硬挺版型不同\n經過水洗讓牛仔布料更加柔軟\n整體彈性更佳\n\n表層做舊工藝帶出復古洗舊感\n則設計上背面口袋置入CARRYON Logo\n更加俐落的設計！\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主',
                prodImgLength: 3,
                descImgs: [],
                descImgLength: 4
            },
            {
                sku: '23SSjeans-BL',
                caption: 'CARRYON 23SS Denim jeans 口袋寬版水洗牛仔褲 藍色',
                spec: 'M-2XL',
                specImg: '',
                buyLink: 'https://forms.gle/Y9x8WLqmhefo17XW8',
                price: 1580,
                specialOffer: null,
                inStock: false,
                image: '',
                series: '23SS',
                fittingDesc: [
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：M', '寬鬆'],
                    ['Female', 'Height：161cm', 'Weight：41kg', 'Size：L', '寬鬆'],
                    ['Male', 'Height：174cm', 'Weight：63kg', 'Size：XL', '寬鬆'],
                    ['Male', 'Height：180cm', 'Weight：61kg', 'Size：2XL', '寬鬆'],
                    ['Male', 'Height：180cm', 'Weight：64kg', 'Size：2XL', '寬鬆'],
                ],
                desc: 'CARRYON 23SS Logo Denim jeans口袋寬版水洗牛仔褲\n\n▲ 配色：黑色、藍色\n▲尺寸：M-2XL\n\n特別選用水洗面料，與以往硬挺版型不同\n經過水洗讓牛仔布料更加柔軟\n整體彈性更佳\n\n表層做舊工藝帶出復古洗舊感\n則設計上背面口袋置入CARRYON Logo\n更加俐落的設計！\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主',
                prodImgLength: 3,
                descImgs: [],
                descImgLength: 4
            },
            {
                sku: '23SS ONOFFTee-BK',
                caption: 'CARRYON 23SS ON&OFF Tee 植絨厚磅短T 黑色',
                spec: 'XL-2XL',
                specImg: '',
                buyLink: 'https://forms.gle/Y9x8WLqmhefo17XW8',
                price: 1080,
                specialOffer: null,
                inStock: true,
                image: '',
                series: '23SS',
                fittingDesc: [
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：XL', '寬鬆'],
                    ['Female', 'Height：161cm', 'Weight：41kg', 'Size：XL', '寬鬆'],
                    ['Male', 'Height：174cm', 'Weight：63kg', 'Size：XL', '合適'],
                    ['Male', 'Height：180cm', 'Weight：61kg', 'Size：2XL', '寬鬆'],
                    ['Male', 'Height：180cm', 'Weight：64kg', 'Size：2XL', '寬鬆'],
                ],
                desc: 'CARRYON 23SS ON&OFF Tee 植絨厚磅短T \n\n▲ 配色：黑色、白色、卡其\n▲ 尺寸：XL、2XL\n\n為了讓整體穿搭更加挺直\n選用10支棉構成\n並以100％全精梳棉製作\n親膚感十足，穿起來舒適\n\n設計上將ON 變成開關\n傳遞在追求夢想的過程中\n隨時切換模式，調整自己步調\n慢慢來，堅持久了就是你的\n\n背面的Be fearless.\n表示無所畏懼往前的追逐吧\n\nMade In Taiwan\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主',
                prodImgLength: 5,
                descImgs: [],
                descImgLength: 4
            },
            {
                sku: '23SS ONOFFTee-WH',
                caption: 'CARRYON 23SS ON&OFF Tee 植絨厚磅短T 白色',
                spec: 'XL-2XL',
                specImg: '',
                buyLink: 'https://forms.gle/Y9x8WLqmhefo17XW8',
                price: 1080,
                specialOffer: null,
                inStock: false,
                image: '',
                series: '23SS',
                fittingDesc: [
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：XL', '寬鬆'],
                    ['Female', 'Height：161cm', 'Weight：41kg', 'Size：XL', '寬鬆'],
                    ['Male', 'Height：174cm', 'Weight：63kg', 'Size：XL', '合適'],
                    ['Male', 'Height：180cm', 'Weight：61kg', 'Size：2XL', '寬鬆'],
                    ['Male', 'Height：180cm', 'Weight：64kg', 'Size：2XL', '寬鬆'],
                ],
                desc: 'CARRYON 23SS ON&OFF Tee 植絨厚磅短T \n\n▲ 配色：黑色、白色、卡其\n▲ 尺寸：XL、2XL\n\n為了讓整體穿搭更加挺直\n選用10支棉構成\n並以100％全精梳棉製作\n親膚感十足，穿起來舒適\n\n設計上將ON 變成開關\n傳遞在追求夢想的過程中\n隨時切換模式，調整自己步調\n慢慢來，堅持久了就是你的\n\n背面的Be fearless.\n表示無所畏懼往前的追逐吧\n\nMade In Taiwan\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主',
                prodImgLength: 3,
                descImgs: [],
                descImgLength: 4
            },
            {
                sku: '23SS ONOFFTee-KA',
                caption: 'CARRYON 23SS ON&OFF Tee 植絨厚磅短T 卡其',
                spec: 'XL-2XL',
                specImg: '',
                buyLink: 'https://forms.gle/Y9x8WLqmhefo17XW8',
                price: 1080,
                specialOffer: null,
                inStock: true,
                image: '',
                series: '23SS',
                fittingDesc: [
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：XL', '寬鬆'],
                    ['Female', 'Height：161cm', 'Weight：41kg', 'Size：XL', '寬鬆'],
                    ['Male', 'Height：174cm', 'Weight：63kg', 'Size：XL', '合適'],
                    ['Male', 'Height：180cm', 'Weight：61kg', 'Size：2XL', '寬鬆'],
                    ['Male', 'Height：180cm', 'Weight：64kg', 'Size：2XL', '寬鬆'],
                ],
                desc: 'CARRYON 23SS ON&OFF Tee 植絨厚磅短T \n\n▲ 配色：黑色、白色、卡其\n▲ 尺寸：XL、2XL\n\n為了讓整體穿搭更加挺直\n選用10支棉構成\n並以100％全精梳棉製作\n親膚感十足，穿起來舒適\n\n設計上將ON 變成開關\n傳遞在追求夢想的過程中\n隨時切換模式，調整自己步調\n慢慢來，堅持久了就是你的\n\n背面的Be fearless.\n表示無所畏懼往前的追逐吧\n\nMade In Taiwan\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主',
                prodImgLength: 3,
                descImgs: [],
                descImgLength: 4
            },
            {
                sku: '23SS logoLS-BK',
                caption: 'CARRYON 23SS Logo L/S Tee 電繡口袋厚磅薄長袖 黑色',
                spec: 'XL-2XL',
                specImg: '',
                buyLink: 'https://forms.gle/Y9x8WLqmhefo17XW8',
                price: 1280,
                specialOffer: null,
                inStock: false,
                image: '',
                series: '23SS',
                fittingDesc: [
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：XL', '寬鬆'],
                    ['Female', 'Height：161cm', 'Weight：41kg', 'Size：XL', '寬鬆'],
                    ['Male', 'Height：174cm', 'Weight：63kg', 'Size：XL', '合適'],
                    ['Male', 'Height：180cm', 'Weight：61kg', 'Size：2XL', '寬鬆'],
                    ['Male', 'Height：180cm', 'Weight：64kg', 'Size：2XL', '寬鬆'],
                ],
                desc: 'CARRYON 23SS Logo L/S Tee 電繡口袋厚磅薄長袖\n\n▲ 配色：黑色、白色、海軍藍\n▲ 尺寸：XL、2XL\n\n春秋冬必備單品-薄長袖\n\n23SS 特別增添口袋配置\n可以放置手機、零錢小物\n\n採用電繡Logo工法\n低調簡單設計穿搭沒煩惱\n\n選用10支棉構成\n並以100％全精梳棉製作\n親膚感十足，穿起來舒適\n\nMade In Taiwan\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主',
                prodImgLength: 3,
                descImgs: [],
                descImgLength: 4
            },
            {
                sku: '23SS logoLS-WH',
                caption: 'CARRYON 23SS Logo L/S Tee 電繡口袋厚磅薄長袖 白色',
                spec: 'XL-2XL',
                specImg: '',
                buyLink: 'https://forms.gle/Y9x8WLqmhefo17XW8',
                price: 1280,
                specialOffer: null,
                inStock: false,
                image: '',
                series: '23SS',
                fittingDesc: [
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：XL', '寬鬆'],
                    ['Female', 'Height：161cm', 'Weight：41kg', 'Size：XL', '寬鬆'],
                    ['Male', 'Height：174cm', 'Weight：63kg', 'Size：XL', '合適'],
                    ['Male', 'Height：180cm', 'Weight：61kg', 'Size：2XL', '寬鬆'],
                    ['Male', 'Height：180cm', 'Weight：64kg', 'Size：2XL', '寬鬆'],
                ],
                desc: 'CARRYON 23SS Logo L/S Tee 電繡口袋厚磅薄長袖\n\n▲ 配色：黑色、白色、海軍藍\n▲ 尺寸：XL、2XL\n\n春秋冬必備單品-薄長袖\n\n23SS 特別增添口袋配置\n可以放置手機、零錢小物\n\n採用電繡Logo工法\n低調簡單設計穿搭沒煩惱\n\n選用10支棉構成\n並以100％全精梳棉製作\n親膚感十足，穿起來舒適\n\nMade In Taiwan\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主',
                prodImgLength: 3,
                descImgs: [],
                descImgLength: 4
            },
            {
                sku: '23SS logoLS-NY',
                caption: 'CARRYON 23SS Logo L/S Tee 電繡口袋厚磅薄長袖 海軍藍',
                spec: 'XL-2XL',
                specImg: '',
                buyLink: 'https://forms.gle/Y9x8WLqmhefo17XW8',
                price: 1280,
                specialOffer: null,
                inStock: false,
                image: '',
                series: '23SS',
                fittingDesc: [
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：XL', '寬鬆'],
                    ['Female', 'Height：161cm', 'Weight：41kg', 'Size：XL', '寬鬆'],
                    ['Male', 'Height：174cm', 'Weight：63kg', 'Size：XL', '合適'],
                    ['Male', 'Height：180cm', 'Weight：61kg', 'Size：2XL', '寬鬆'],
                    ['Male', 'Height：180cm', 'Weight：64kg', 'Size：2XL', '寬鬆'],
                ],
                desc: 'CARRYON 23SS Logo L/S Tee 電繡口袋厚磅薄長袖\n\n▲ 配色：黑色、白色、海軍藍\n▲ 尺寸：XL、2XL\n\n春秋冬必備單品-薄長袖\n\n23SS 特別增添口袋配置\n可以放置手機、零錢小物\n\n採用電繡Logo工法\n低調簡單設計穿搭沒煩惱\n\n選用10支棉構成\n並以100％全精梳棉製作\n親膚感十足，穿起來舒適\n\nMade In Taiwan\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主',
                prodImgLength: 3,
                descImgs: [],
                descImgLength: 3
            },
            {
                sku: '23SS Reusable food ware',
                caption: 'CARRYON 23SS Reusable food ware 小麥環保 四件餐具組',
                spec: 'O/S',
                specImg: '',
                buyLink: 'https://forms.gle/Y9x8WLqmhefo17XW8',
                price: 280,
                specialOffer: null,
                inStock: true,
                image: '',
                series: '23SS',
                fittingDesc: [],
                desc: 'CARRYON 23SS Reusable food ware 小麥環保 四件餐具組 \t\t\t\n\n配色：深藍色、小麥色、湖水綠、哈密瓜綠、天空藍\n\n尺寸: 5 * 10.5 * 2.3 cm\n\n材料：小麥秸稈\n\n不論是出門在外、辦公外食\n都需要一組環保餐具\n\n簡單好攜帶\n四件組一次滿足需求\n湯匙 叉子 筷子 刀子\n\n可拆卸的設計\n小小的一盒放在包包不佔空間\n餐具貼心的圓滑設計\n讓我們使用上更佳安全\n\nMade In Taiwan\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主',
                prodImgLength: 2,
                descImgs: [],
                descImgLength: 0
            },
            {
                sku: '23SS belt',
                caption: 'CARRYON 23SS Clip Belt Chrome Logo 金屬夾式腰帶',
                spec: 'O/S',
                specImg: '',
                buyLink: 'https://forms.gle/Y9x8WLqmhefo17XW8',
                price: 780,
                specialOffer: null,
                inStock: true,
                image: '',
                series: '23SS',
                fittingDesc: [],
                desc: 'CARRYON 23SS Clip Belt Chrome Logo 金屬夾式腰帶\n\n▲ 配色：銀色、黑色\n▲ 尺寸: 長度120cm\n\n升級！升級！\n腰帶採用鏡面金屬及霧面黑配置\n更加有質感，整體輕盈許多\n\n喜歡穿寬鬆的朋友\n都需要一條腰帶\n\n我們以實際需求出發\n使用雷射雕刻技術將 Logo 注入\n\n簡單的設定\n在使用上只要一個步驟就能輕鬆扣緊\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主',
                prodImgLength: 2,
                descImgs: [],
                descImgLength: 4
            },
            {
                sku: '23SS Camp cap-BK',
                caption: 'CARRYON 23SS Logo Camp cap 電繡可調式五分割 黑色',
                spec: 'O/S',
                specImg: '',
                buyLink: 'https://forms.gle/Y9x8WLqmhefo17XW8',
                price: 1080,
                specialOffer: null,
                inStock: false,
                image: '',
                series: '23SS',
                fittingDesc: [],
                desc: 'CARRYON 23SS Logo Camp cap 電繡可調式五分割\n\n▲ 配色：黑色、深灰、卡其色\n\n▲ 尺寸: 頭圍可調整\n\n採用尼龍面料構成\n透氣、防潑水、平滑特性\n戴起來舒適方便\n\n簡單的Logo 電繡設計\n隨意搭配都好看\n\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主',
                prodImgLength: 2,
                descImgs: [],
                descImgLength: 3
            },
            // {
            //     sku: '23SS Camp cap-GY',
            //     caption: 'CARRYON 23SS Logo Camp cap 電繡可調式五分割 深灰',
            //     spec: 'O/S',
            //     specImg: '',
            //     buyLink: '',
            //     price: 1080,
            //     specialOffer: null,
            //     inStock: true,
            //     image: '',
            //     series: 'CARRYON 23SS',
            //     fittingDesc: [],
            //     desc: 'CARRYON 23SS Logo Camp cap 電繡可調式五分割\n\n▲ 配色：黑色、深灰、卡其色\n\n▲ 尺寸: 頭圍可調整\n\n採用尼龍面料構成\n透氣、防潑水、平滑特性\n戴起來舒適方便\n\n簡單的Logo 電繡設計\n隨意搭配都好看\n\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主',
            //     prodDescImgs: [],
            //     descImgs: [],
            // },
            {
                sku: '23SS Camp cap-KA',
                caption: 'CARRYON 23SS Logo Camp cap 電繡可調式五分割 卡其色',
                spec: 'O/S',
                specImg: '',
                buyLink: 'https://forms.gle/Y9x8WLqmhefo17XW8',
                price: 1080,
                specialOffer: null,
                inStock: false,
                image: '',
                series: '23SS',
                fittingDesc: [],
                desc: 'CARRYON 23SS Logo Camp cap 電繡可調式五分割\n\n▲ 配色：黑色、深灰、卡其色\n\n▲ 尺寸: 頭圍可調整\n\n採用尼龍面料構成\n透氣、防潑水、平滑特性\n戴起來舒適方便\n\n簡單的Logo 電繡設計\n隨意搭配都好看\n\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主',
                prodImgLength: 2,
                descImgs: [],
                descImgLength: 2
            },
            {
                sku: '23SS Reusable bag',
                caption: 'CARRYON 23SS Reusable bag 可折疊 抗撕裂 收納環保袋',
                spec: 'O/S',
                specImg: '',
                buyLink: 'https://forms.gle/Y9x8WLqmhefo17XW8',
                price: 580,
                specialOffer: null,
                inStock: true,
                image: '',
                series: '23SS',
                fittingDesc: [],
                desc: 'CARRYON 23SS Reusable bag 可折疊 抗撕裂 收納環保袋\n\n▲ 配色：黑色、軍綠\n\n▲ 尺寸: 65（含背帶）x36x26cm\n▲ 收納後尺寸：15x16cm\n▲ 容量:27L\n\n使用再生纖維100%面料製成\n防水抗撕裂材質 \n內層有一個小內袋可裝置小物\n\n網眼袋部分有鈕扣\n能放置許多物品，放入筆電也沒問題\n\n耐用又攜帶方便\n出門在外不用再花錢買袋子\n\nMade In Japan\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主',
                prodImgLength: 2,
                descImgs: [],
                descImgLength: 4
            },
            {
                sku: '23SS Ripstop bag',
                caption: 'CARRYON 23SS Ripstop bag 束口收納小包',
                spec: 'O/S',
                specImg: '',
                buyLink: 'https://forms.gle/Y9x8WLqmhefo17XW8',
                price: 580,
                specialOffer: null,
                inStock: true,
                image: '',
                series: '23SS',
                fittingDesc: [],
                desc: 'CARRYON 23SS Ripstop bag 束口收納小包\n\n\n▲ 配色：黑色、軍綠\n\n▲ 尺寸: 26x38cm\n▲ 束小包後尺寸：25cm\n▲ 容量: 6L\n\n使用再生纖維100%面料製成\n防水抗撕裂材質 \n內層有一個小內袋可裝置小物\n\n2WAY束帶式設計\n一拉馬上變成圓形小包\n出門攜帶方便\n\nMade In Japan\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主',
                prodImgLength: 2,
                descImgs: [],
                descImgLength: 4
            },
            {
                sku: '23SS Throw pillow',
                caption: 'CARRYON 23SS Logo Throw pillow 圓形抱枕',
                spec: 'O/S',
                specImg: '',
                buyLink: 'https://forms.gle/Y9x8WLqmhefo17XW8',
                price: 580,
                specialOffer: null,
                inStock: true,
                image: '',
                series: '23SS',
                fittingDesc: [],
                desc: 'CARRYON 23SS Logo Throw pillow 圓形抱枕\n\n▲ 尺寸: 40*40cm\n\nMade In Taiwan\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主',
                prodImgLength: 2,
                descImgs: [],
                descImgLength: 2
            },
            {
                sku: '23SS sticker',
                caption: 'CARRYON 23SS Logo 防水霧面 貼紙組合包 五入',
                spec: 'O/S',
                specImg: '',
                buyLink: 'https://forms.gle/Y9x8WLqmhefo17XW8',
                price: 350,
                specialOffer: null,
                inStock: false,
                image: '',
                series: '23SS',
                fittingDesc: [],
                desc: 'CARRYON 23SS Logo 防水霧面 貼紙組合包                   \n\n▲ 尺寸: 5*5 cm \n\n▲ 此為防水材質，黏貼撕下不留痕跡\n\nMade In Taiwan\n\n【注意事項】欲購買請填寫表單，後續將有客服與您聯絡，確認已匯款金額\n\n【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主\n\n【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主',
                prodImgLength: 1,
                descImgs: [],
                descImgLength: 3
            },
        ],
    },
    {
        name: 'CARRYON 22FW',
        subTitle: '',
        list: [
            // 連帽上衣
            {
                sku: '22FW hoodie-BK1',
                caption: 'CARRYON 22FW Energy Hoodie 閃電 連帽上衣 黑',
                spec: 'L-2XL',
                specImg:
                    '/image/product/2023-01/size/CARRYON 22FW Energy Hoodie 閃電 連帽上衣.webp',
                buyLink: 'https://forms.gle/uM7HkFfMw4XU9EjY9',
                price: 1680,
                // specialOffer: 980,
                inStock: true,
                image: '/image/product/2023-01/hoodie_bk1',
                fittingDesc: [
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：L', '寬鬆'],
                    ['Male', 'Height：174cm', 'Weight：63kg', 'Size：XL', '寬鬆'],
                ],
                desc: `CARRYON 22FW Energy Hoodie 閃電 連帽上衣 黑

                推出首次獨特版型，寬鬆剪裁、無口袋無抽繩、下擺縮口羅紋材質縮短，袖口細節處置入全新織標，版型俐落乾淨，以舒適面料為底，觸感柔軟不起毛球，專注生活穿搭實用性，為薄款連帽上衣，可穿著運動、逛街等，外面可多層式搭配，不過於太悶熱！具備適度份量感
                
                胸前藍色閃電象徵「能量」
                提倡大家累了該好好休息
                為自己充電，再充滿電的下一次 
                重新帶著這份的能量 繼續發熱吧！
                
                【注意事項】確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨
                
                【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                
                【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽上衣 黑/1.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽上衣 黑/2.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽上衣 黑/3.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽上衣 黑/4.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽上衣 黑/5.png',
                ],
            },
            {
                sku: '22FW hoodie-GY1',
                caption: 'CARRYON 22FW Energy Hoodie 閃電 連帽上衣 淺灰',
                spec: 'L-2XL',
                specImg:
                    '/image/product/2023-01/size/CARRYON 22FW Energy Hoodie 閃電 連帽上衣.webp',
                buyLink: 'https://forms.gle/uM7HkFfMw4XU9EjY9',
                price: 1680,
                // specialOffer: 980,
                inStock: false,
                image: '/image/product/2023-01/hoodie_gynew1',
                fittingDesc: [
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：L', '寬鬆'],
                    ['Male', 'Height：174cm', 'Weight：63kg', 'Size：XL', '寬鬆'],
                ],
                desc: `CARRYON 22FW Energy Hoodie 閃電 連帽上衣 淺灰

                推出首次獨特版型，寬鬆剪裁、無口袋無抽繩、下擺縮口羅紋材質縮短，袖口細節處置入全新織標，版型俐落乾淨，以舒適面料為底，觸感柔軟不起毛球，專注生活穿搭實用性，為薄款連帽上衣，可穿著運動、逛街等，外面可多層式搭配，不過於太悶熱！具備適度份量感
                
                胸前藍色閃電象徵「能量」
                傳遞累了，該好好休息
                為自己充電，再充滿電的下一次 
                重新帶著這份的能量 繼續發熱吧！
                
                【注意事項】確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨
                
                【商品數據】為人工測量，可能會有正負2cm以內誤差，請商品以實物為主
                
                【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽上衣 淺灰/1.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽上衣 淺灰/2.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽上衣 淺灰/3.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽上衣 淺灰/4.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽上衣 淺灰/5.png',
                ],
            },

            // 燈芯褲
            {
                sku: '22FW corduroy pants-BG1',
                caption: 'CARRYON 22FW Logo Pant 刺繡 燈芯絨褲 卡其',
                spec: '28, 30, 32, 34',
                specImg:
                    '/image/product/2023-01/size/CARRYON 22FW Logo Pant 刺繡 燈芯絨褲.webp',
                buyLink: 'https://forms.gle/uM7HkFfMw4XU9EjY9',
                price: 1880,
                // specialOffer: 980,
                inStock: true,
                image: '/image/product/2023-01/pant_1',
                fittingDesc: [
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：30', '寬鬆'],
                    ['Female', 'Height：161cm', 'Weight：44kg', 'Size：28', '適中'],
                    ['Male', 'Height：165cm', 'Weight：55kg', 'Size：30', '適中'],
                    ['Male', 'Height：174cm', 'Weight：63kg', 'Size：30', '適中'],
                    ['Male', 'Height：183cm', 'Weight：68kg', 'Size：34', '適中'],
                ],
                desc: `CARRYON 22FW Logo Pant 刺繡 燈芯絨褲 卡其

                秋冬穿搭必備單品-燈心絨褲，為寒冷的冬天注入暖感，研發出專屬的寬鬆直筒版型，穿搭起來超有型！共有兩種口袋的設定，日常攜帶的手機錢包都能輕易放入
                
                版型寬鬆舒適，一穿比例馬上拉高，細節處於膝蓋上置入刺繡 Logo，背後則有 CARRYON 標籤，前後呼應！
                
                【注意事項】確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨
                
                【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                
                【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodDescImgs: [
                    '/image/product/2023-01/pant_4.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2023-01/desc/CARRYON 22FW 燈心絨褲 卡其/1.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 燈心絨褲 卡其/2.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 燈心絨褲 卡其/3.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 燈心絨褲 卡其/4.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 燈心絨褲 卡其/5.png',
                ],
            },
            {
                sku: '22FW corduroy pants-KH1',
                caption: 'CARRYON 22FW Logo Pant 刺繡 燈芯絨褲 灰綠',
                spec: '28, 30, 32, 34',
                specImg:
                    '/image/product/2023-01/size/CARRYON 22FW Logo Pant 刺繡 燈芯絨褲.webp',
                buyLink: 'https://forms.gle/uM7HkFfMw4XU9EjY9',
                price: 1880,
                // specialOffer: 980,
                inStock: false,
                image: '/image/product/2023-01/pant_3',
                fittingDesc: [
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：30', '寬鬆'],
                    ['Female', 'Height：161cm', 'Weight：44kg', 'Size：28', '適中'],
                    ['Male', 'Height：165cm', 'Weight：55kg', 'Size：30', '適中'],
                    ['Male', 'Height：174cm', 'Weight：63kg', 'Size：30', '適中'],
                    ['Male', 'Height：183cm', 'Weight：68kg', 'Size：34', '適中'],
                ],
                desc: `CARRYON 22FW Logo Pant 刺繡 燈芯絨褲 灰綠

                秋冬穿搭必備單品-燈心絨褲，為寒冷的冬天注入暖感，研發出專屬的寬鬆直筒版型，穿搭起來超有型！共有兩種口袋的設定，日常攜帶的手機錢包都能輕易放入
                
                版型寬鬆舒適，一穿比例馬上拉高，細節處於膝蓋上置入刺繡 Logo，背後則有 CARRYON 標籤，前後呼應！
                
                【 注意事項】確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨
                
                【 商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                
                【 色差 】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodDescImgs: [
                    '/image/product/2023-01/pant_5.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2023-01/desc/CARRYON 22FW 燈心絨褲 軍綠/1.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 燈心絨褲 軍綠/2.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 燈心絨褲 軍綠/3.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 燈心絨褲 軍綠/4.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 燈心絨褲 軍綠/5.png',
                ],
            },

            // 外套
            {
                sku: '22FW hooded jacket-BK1',
                caption: 'CARRYON 22FW Zip Hoodie 刺繡 Logo 連帽外套 黑',
                spec: 'XL-2XL',
                specImg:
                    '/image/product/2023-01/size/CARRYON 22FW Zip Hoodie 刺繡 Logo 連帽外套.webp',
                buyLink: 'https://forms.gle/vSbryNK3k9KQq8bE6',
                price: 1580,
                // specialOffer: 980,
                inStock: false,
                image: '/image/product/2023-01/jacket_bk2',
                fittingDesc: [
                    ['Female', 'Height：161cm', 'Weight：44kg', 'Size：XL', '寬鬆'],
                    ['Female', 'Height：165cm', 'Weight：55kg', 'Size：XL', '適中'],
                    ['Male', 'Height：183cm', 'Weight：68kg', 'Size：XL', '適中'],
                ],
                desc: `CARRYON 22FW Zip Hoodie 刺繡 Logo 連帽外套 黑

                首次推出內刷毛連帽外套，接近生活的實穿款式，內外雙層抗寒，保暖效果提升 ，100% 棉質作為基礎設定，布料觸感滑順厚實，連帽帽型立體設計，加強防風效果，金屬拉鍊設定穿脫方便，是外出方便的日常衣物
                
                正面為刺繡 Logo，背面為標語，簡單的設計帶出品牌理念，時時刻刻提醒堅持夢想，為了自己堅持，共有四色推出 黑色/深灰/海軍藍/寶藍，不同配色皆有不同個性
                                                                                            
                
                【注意事項】確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨
                
                【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                
                【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽外套 黑/1.webp',
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽外套 黑/2.webp',
                ],
            },
            {
                sku: '22FW hooded jacket-GY1',
                caption: 'CARRYON 22FW Zip Hoodie 刺繡 Logo 連帽外套 深灰',
                spec: 'XL-2XL',
                specImg:
                    '/image/product/2023-01/size/CARRYON 22FW Zip Hoodie 刺繡 Logo 連帽外套.webp',
                buyLink: 'https://forms.gle/vSbryNK3k9KQq8bE6',
                price: 1580,
                // specialOffer: 980,
                inStock: false,
                image: '/image/product/2023-01/jacket_gy2',
                fittingDesc: [
                    ['Female', 'Height：161cm', 'Weight：44kg', 'Size：XL', '寬鬆'],
                    ['Female', 'Height：165cm', 'Weight：55kg', 'Size：XL', '適中'],
                    ['Male', 'Height：183cm', 'Weight：68kg', 'Size：XL', '適中'],
                ],
                desc: `CARRYON 22FW Zip Hoodie 刺繡 Logo 連帽外套 深灰

                首次推出內刷毛連帽外套，接近生活的實穿款式，內外雙層抗寒，保暖效果提升 ，100% 棉質作為基礎設定，布料觸感滑順厚實，連帽帽型立體設計，加強防風效果，金屬拉鍊設定穿脫方便，是外出方便的日常衣物
                
                正面為刺繡 Logo，背面為標語，簡單的設計帶出品牌理念，時時刻刻提醒堅持夢想，為了自己堅持，共有四色推出 黑色/深灰/海軍藍/寶藍，不同配色皆有不同個性
                                                                                            
                
                【 注意事項】確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨
                
                【 商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                
                【 色差 】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽外套 灰/1.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽外套 灰/2.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽外套 灰/3.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽外套 灰/4.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽外套 灰/5.png',
                ],
            },
            {
                sku: '22FW hooded jacket-NB1',
                caption: 'CARRYON 22FW Zip Hoodie 刺繡 Logo 連帽外套 海軍藍',
                spec: 'XL-2XL',
                specImg:
                    '/image/product/2023-01/size/CARRYON 22FW Zip Hoodie 刺繡 Logo 連帽外套.webp',
                buyLink: 'https://forms.gle/vSbryNK3k9KQq8bE6',
                price: 1580,
                // specialOffer: 980,
                inStock: false,
                image: '/image/product/2023-01/jacket_NV1',
                fittingDesc: [
                    ['Female', 'Height：161cm', 'Weight：44kg', 'Size：XL', '寬鬆'],
                    ['Female', 'Height：165cm', 'Weight：55kg', 'Size：XL', '適中'],
                    ['Male', 'Height：183cm', 'Weight：68kg', 'Size：XL', '適中'],
                ],
                desc: `CARRYON 22FW Zip Hoodie 刺繡 Logo 連帽外套 海軍藍

                首次推出內刷毛連帽外套，接近生活的實穿款式，內外雙層抗寒，保暖效果提升 ，100% 棉質作為基礎設定，布料觸感滑順厚實，連帽帽型立體設計，加強防風效果，金屬拉鍊設定穿脫方便，是外出方便的日常衣物
                
                正面為刺繡 Logo，背面為標語，簡單的設計帶出品牌理念，時時刻刻提醒堅持夢想，為了自己堅持，共有四色推出 黑色/深灰/海軍藍/寶藍，不同配色皆有不同個性
                                                                                            
                
                【注意事項】確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨
                
                【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                
                【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽外套 海軍藍/1.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽外套 海軍藍/2.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽外套 海軍藍/3.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽外套 海軍藍/4.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽外套 海軍藍/5.png',
                ],
            },
            {
                sku: '22FW hooded jacket-RB1',
                caption: 'CARRYON 22FW Zip Hoodie 刺繡 Logo 連帽外套 寶藍',
                spec: 'XL-2XL',
                specImg:
                    '/image/product/2023-01/size/CARRYON 22FW Zip Hoodie 刺繡 Logo 連帽外套.webp',
                buyLink: 'https://forms.gle/vSbryNK3k9KQq8bE6',
                price: 1580,
                // specialOffer: 980,
                inStock: false,
                image: '/image/product/2023-01/jacket_bl2',
                fittingDesc: [
                    ['Female', 'Height：161cm', 'Weight：44kg', 'Size：XL', '寬鬆'],
                    ['Female', 'Height：165cm', 'Weight：55kg', 'Size：XL', '適中'],
                    ['Male', 'Height：183cm', 'Weight：68kg', 'Size：XL', '適中'],
                ],
                desc: `CARRYON 22FW Zip Hoodie 刺繡 Logo 連帽外套 寶藍

                首次推出內刷毛連帽外套，接近生活的實穿款式，內外雙層抗寒，保暖效果提升 ，100% 棉質作為基礎設定，布料觸感滑順厚實，連帽帽型立體設計，加強防風效果，金屬拉鍊設定穿脫方便，是外出方便的日常衣物
                
                正面為刺繡 Logo，背面為標語，簡單的設計帶出品牌理念，時時刻刻提醒堅持夢想，為了自己堅持，共有四色推出 黑色/深灰/海軍藍/寶藍，不同配色皆有不同個性
                                                                                            
                
                【注意事項】確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨
                
                【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                
                【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽外套 寶藍/1.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽外套 寶藍/2.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽外套 寶藍/3.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽外套 寶藍/4.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 連帽外套 寶藍/5.png',
                ],
            },

            // 帽子
            {
                sku: '22FW flight cap-BK1',
                caption: 'CARRYON 22FW Flight cap Logo 遮耳飛行帽 黑',
                spec: 'One Size',
                specImg: null,
                buyLink: 'https://forms.gle/vSbryNK3k9KQq8bE6',
                price: 1080,
                // specialOffer: 980,
                inStock: false,
                image:
                    '/image/product/2023-01/CARRYON 22FW Flight cap Logo 遮耳飛行帽 黑',
                fittingDesc: [['N/A']],
                desc: `CARRYON 22FW Flight cap Logo 遮耳飛行帽 黑

                大家最愛的飛行帽來囉！簡約的 Logo 設計，因應季節採用內裡刷毛布料，能有效提升保溫效果，表面為防水面料，輕盈的設定不厚重，後方有伸縮拉繩可依照個人調整頭圍，則帽繩能固定好帽款，不輕易脫落，是出遊露營必備的輕量保暖單品，簡約的帽款蘊含著巧思，千萬別錯過！
                                                                                                                            
                【 注意事項】確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨
                
                【 商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                
                【 色差 】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodDescImgs: [
                    // '/image/product/2023-01/cap_3.webp',
                    // '/image/product/2023-01/cap_4.webp',
                    // '/image/product/2023-01/cap_5.webp',
                ],
                descImgs: [
                    '/image/product/2023-01/desc/CARRYON 22FW 飛行帽 黑/3.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 飛行帽 黑/4.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 飛行帽 黑/5.png',
                ],
            },
            {
                sku: '22FW flight cap-GY1',
                caption: 'CARRYON 22FW Flight cap Logo 遮耳飛行帽 灰',
                spec: 'One Size',
                specImg: null,
                buyLink: 'https://forms.gle/vSbryNK3k9KQq8bE6',
                price: 1080,
                // specialOffer: 980,
                inStock: false,
                image:
                    '/image/product/2023-01/CARRYON 22FW Flight cap Logo 遮耳飛行帽 灰',
                fittingDesc: [['N/A']],
                desc: `CARRYON 22FW Flight cap Logo 遮耳飛行帽 灰

                大家最愛的飛行帽來囉！簡約的 Logo 設計，因應季節採用內裡刷毛布料，能有效提升保溫效果，表面為防水面料，輕盈的設定不厚重，後方有伸縮拉繩可依照個人調整頭圍，則帽繩能固定好帽款，不輕易脫落，是出遊露營必備的輕量保暖單品，簡約的帽款蘊含著巧思，千萬別錯過！
                
                                                                                                                                
                【 注意事項】確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨
                
                【 商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                
                【 色差 】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodDescImgs: [
                    // '/image/product/2023-01/cap_3.webp',
                    // '/image/product/2023-01/cap_4.webp',
                    // '/image/product/2023-01/cap_5.webp',
                ],
                descImgs: [
                    '/image/product/2023-01/desc/CARRYON 22FW 飛行帽 灰/1.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 飛行帽 灰/2.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 飛行帽 灰/3.png',
                ],
            },

            // 毛帽
            {
                sku: '22FW beanie-BK1',
                caption: 'CARRYON 22FW Logo Beanie 小標毛帽 黑',
                spec: 'One Size',
                specImg:
                    '/image/product/2023-01/size/CARRYON 22FW Logo Beanie 小標毛帽.webp',
                buyLink: 'https://forms.gle/uM7HkFfMw4XU9EjY9',
                price: 880,
                // specialOffer: 980,
                inStock: true,
                image: '/image/product/2023-01/beanie-BK1',
                fittingDesc: [['N/A']],
                desc: `CARRYON 22FW Logo Beanie 小標毛帽 黑

                採用針織組織製作，配戴時整體包覆性更佳，不易變形，能在良好的帽型下穿搭，享受舒適保暖！能看見右下細節處注入全新織標，正面為 logo，反面則是標語「YOU TO CARRYON FOU YOU」，呼籲品牌理念
                
                推出基礎配色黑色 / 軍綠 
                
                尺寸：高 16cm/寬 18cm，有彈性(56-60cm)
                 
                【注意事項】確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨
                
                【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                
                【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodDescImgs: [
                    // '/image/product/2023-01/beanie_1.webp',
                    // '/image/product/2023-01/beanie_2.webp',
                ],
                descImgs: [
                    '/image/product/2023-01/desc/CARRYON 22FW 毛帽 黑/1.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 毛帽 黑/2.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 毛帽 黑/3.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 毛帽 黑/4.png',
                ],
            },
            {
                sku: '22FW beanie-KH1',
                caption: 'CARRYON 22FW Logo Beanie 小標毛帽 軍綠',
                spec: 'One Size',
                specImg:
                    '/image/product/2023-01/size/CARRYON 22FW Logo Beanie 小標毛帽.webp',
                buyLink: 'https://forms.gle/uM7HkFfMw4XU9EjY9',
                price: 880,
                // specialOffer: 980,
                inStock: false,
                image: '/image/product/2023-01/beanie-KH1',
                fittingDesc: [['N/A']],
                desc: `CARRYON 22FW Logo Beanie 小標毛帽 軍綠

                採用針織組織製作，配戴時整體包覆性更佳，不易變形，能在良好的帽型下穿搭，享受舒適保暖！能看見右下細節處注入全新織標，正面為 logo，反面則是標語「YOU TO CARRYON FOU YOU」，呼籲品牌理念
                
                推出基礎配色 黑色 / 軍綠 
                
                尺寸：高 16cm/寬 18cm，有彈性(56-60cm)
                 
                【注意事項】確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨
                
                【商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                
                【色差】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodDescImgs: [
                    // '/image/product/2023-01/beanie_1.webp',
                    // '/image/product/2023-01/beanie_2.webp',
                ],
                descImgs: [
                    '/image/product/2023-01/desc/CARRYON 22FW 毛帽 軍綠/1.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 毛帽 軍綠/2.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 毛帽 軍綠/3.png',
                ],
            },

            // 腰帶
            {
                sku: '22FW logo canvas belt-BK1',
                caption: 'CARRYON 22FW Clip Belt Chrome Logo  金屬腰帶',
                spec: 'One Size',
                specImg:
                    '/image/product/2023-01/size/CARRYON 22FW Clip Belt Chrome Logo  金屬腰帶_.webp',
                buyLink: 'https://forms.gle/vSbryNK3k9KQq8bE6',
                price: 780,
                // specialOffer: 980,
                inStock: false,
                image: '/image/product/2023-01/belt',
                fittingDesc: [['N/A']],
                desc: `CARRYON 22FW Clip Belt Chrome Logo  金屬腰帶 

                CARRYON 首次推出，褲子太寬鬆需要一條腰帶輔助，因為這個需求，腰帶也成為了穿搭中必備的單品之一，我們以實際需求出發，使用雷射雕刻技術將 Logo 注入，簡單的設定，在使用上只要一個步驟就能輕鬆扣緊，硬挺編織帆布材質，將褲子撐起整體造型提升不少層次！
                
                尺寸：長度 110cm                                                                                                              
                
                【 注意事項】確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨
                
                【 商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                
                【 色差 】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2023-01/desc/CARRYON 22FW 經典 Logo 腰帶/1.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 經典 Logo 腰帶/2.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 經典 Logo 腰帶/3.png',
                ],
            },

            // 外出包
            {
                sku: '22FW logo fuction outdoor bag-BK1',
                caption: 'CARRYON 22FW CORDURA® Pocket Pouch 機能外出收納包（大）',
                spec: 'One Size',
                specImg:
                    '/image/product/2023-01/size/CARRYON 22FW CORDURA® Pocket Pouch 機能外出收納包.webp',
                buyLink: 'https://forms.gle/uM7HkFfMw4XU9EjY9',
                price: 880,
                // specialOffer: 980,
                inStock: false,
                image:
                    '/image/product/2023-01/CARRYON 22FW Pocket Pouch 機能外出收納包（大）',
                fittingDesc: [['N/A']],
                desc: `CARRYON 22FW Pocket Pouch 機能外出收納包（大）

                經典 Logo 燙印，兩分層收納，將短途外出必需攜帶的物品一併納入收納需求，布料採用 CORDURA® 防潑水尼龍面料，內附抽繩背帶、掛腕戴，包體結構設計可自行更換喜歡的吊繩，正面拉鍊夾層最大可容納 6.5 寸手機，背面插袋夾層可收納零錢、卡片等小物
                
                尺寸：長度 16cm / 寬度 11cm                                                                                                             
                
                【 注意事項】確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨
                
                【 商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                
                【 色差 】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [],
            },
            {
                sku: '22FW logo fuction outdoor bag-S1',
                caption: 'CARRYON 22FW CORDURA® Pocket Pouch 機能外出收納包（小）',
                spec: 'One Size',
                specImg:
                    '/image/product/2023-01/size/CARRYON 22FW CORDURA® Pocket Pouch 機能外出收納包.webp',
                buyLink: 'https://forms.gle/uM7HkFfMw4XU9EjY9',
                price: 780,
                // specialOffer: 980,
                inStock: true,
                image:
                    '/image/product/2023-01/CARRYON 22FW Pocket Pouch 機能外出收納包（小）',
                fittingDesc: [['N/A']],
                desc: `"CARRYON 22FW CORDURA® Pocket Pouch 機能外出收納包（小）

                採用 CORDURA® 防潑水尼龍面料，內附抽繩背帶，包體結構設計可自行更換喜歡的吊繩，背面插袋夾層可收納零錢、卡片等小物，經典 Logo 燙印，兩分層收納，將短途外出必需攜帶的物品一併納入收納需求
                
                共推出黑色/卡其/軍綠
                
                尺寸：長度 13cm / 寬度 9cm 
                
                【 注意事項】確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨
                
                【 商品數據】為人工測量，可能會有正負 2cm 以內誤差，請商品以實物為主
                
                【 色差 】所有商品圖片皆為實物拍攝，可能由於拍攝光線、電腦顯示器色差等因素，照片與實物會略有差別，請商品以實物為主`,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2023-01/desc/CARRYON 22FW 機能外出收納包（小） /1.png',
                    '/image/product/2023-01/desc/CARRYON 22FW 機能外出收納包（小） /2.png',
                ],
            },
        ],
    },
    {
        name: 'CARRYON X FOREST',
        list: [
            {
                sku: 'CARRYON-FOREST-GN',
                caption: 'CARRYON x FOREST 22FW Stay High Stay Cool 深綠 短T',
                spec: 'XL-3XL',
                specImg: '/image/product/2022-10/desc/size.webp',
                buyLink: 'https://forms.gle/XZXnG5H3n7w8hwgM8',
                price: 1080,
                // specialOffer: 980,
                inStock: false,
                image: '/image/product/2022-10/CARRYON-FOREST-GN',
                fittingDesc: [
                    ['Female', 'Height：152cm', 'Weight：48kg', 'Size：2XL', '寬鬆'],
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：2XL', '寬鬆'],
                    ['Male', 'Height：174cm', 'Weight：61kg', 'Size：2XL', '舒適'],
                ],
                desc: `在追逐夢想的過程中，難免有精疲力竭的時候，
        透過品嚐自己喜愛的事物，帶著這份動力，繼續前進；
        在生活中透過不斷的學習、攝取、消化，
        持續成長的同時請告訴自己：『保有能量，保持自己喜愛的樣貌』！                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                      
         - 衣料材質採用台灣棉質製成，親膚排汗。
                                                                                                                       
         - 注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨。`,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-10/desc/1.webp',
                    '/image/product/2022-10/desc/2.webp',
                    '/image/product/2022-10/desc/3.webp',
                    '/image/product/2022-10/desc/4.webp',
                    '/image/product/2022-10/desc/5.webp',
                    '/image/product/2022-10/desc/6.webp',
                ],
            },

            {
                sku: 'CARRYON-FOREST-GY',
                caption: 'CARRYON x FOREST 22FW Stay High Stay Cool 麻灰色 短T',
                spec: 'XL-3XL',
                specImg: '/image/product/2022-10/desc/size.webp',
                buyLink: 'https://forms.gle/XZXnG5H3n7w8hwgM8',
                price: 1080,
                // specialOffer: 980,
                inStock: false,
                image: '/image/product/2022-10/CARRYON-FOREST-GY',
                fittingDesc: [
                    ['Female', 'Height：152cm', 'Weight：48kg', 'Size：2XL', '寬鬆'],
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：2XL', '寬鬆'],
                    ['Male', 'Height：174cm', 'Weight：61kg', 'Size：2XL', '舒適'],
                ],
                desc: `在追逐夢想的過程中，難免有精疲力竭的時候，
        透過品嚐自己喜愛的事物，帶著這份動力，繼續前進；
        在生活中透過不斷的學習、攝取、消化，
        持續成長的同時請告訴自己：『保有能量，保持自己喜愛的樣貌』！                                                                                                                                                                                                                                                                                                      
                                                                                                                                                                                                                                                                                                                      
         - 衣料材質採用台灣棉質製成，親膚排汗。
                                                                                                                       
         - 注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨。`,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-10/desc/1.webp',
                    '/image/product/2022-10/desc/2.webp',
                    '/image/product/2022-10/desc/3.webp',
                    '/image/product/2022-10/desc/4.webp',
                    '/image/product/2022-10/desc/5.webp',
                    '/image/product/2022-10/desc/6.webp',
                ],
            },

            {
                sku: 'CARRYON-FOREST-BK',
                caption: 'CARRYON x FOREST 22FW Stay High Stay Cool 黑色 短T',
                spec: 'XL-3XL',
                specImg: '/image/product/2022-10/desc/size.webp',
                buyLink: 'https://forms.gle/XZXnG5H3n7w8hwgM8',
                price: 1080,
                // specialOffer: 980,
                inStock: false,
                image: '/image/product/2022-10/CARRYON-FOREST-BK',
                fittingDesc: [
                    ['Female', 'Height：152cm', 'Weight：48kg', 'Size：2XL', '寬鬆'],
                    ['Female', 'Height：159cm', 'Weight：44kg', 'Size：2XL', '寬鬆'],
                    ['Male', 'Height：174cm', 'Weight：61kg', 'Size：2XL', '舒適'],
                ],
                desc: `在追逐夢想的過程中，難免有精疲力竭的時候，
        透過品嚐自己喜愛的事物，帶著這份動力，繼續前進；
        在生活中透過不斷的學習、攝取、消化，
        持續成長的同時請告訴自己：『保有能量，保持自己喜愛的樣貌』！                                                                                                                                                                                                                                                                                                      
                                                                                                                                                                                                                                                                                                                      
         - 衣料材質採用台灣棉質製成，親膚排汗。
                                                                                                                       
         - 注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨。`,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-10/desc/1.webp',
                    '/image/product/2022-10/desc/2.webp',
                    '/image/product/2022-10/desc/3.webp',
                    '/image/product/2022-10/desc/4.webp',
                    '/image/product/2022-10/desc/5.webp',
                    '/image/product/2022-10/desc/6.webp',
                ],
            },
        ],
    },
    {
        name: 'CARRYON 22SS August',
        list: [
            {
                sku: '22SSAugustSocks-Double',
                caption: 'CARRYON 22S/S August Logo 長襪  一組',
                spec: 'One Size',
                specImg: '/image/product/2022-8/decs/襪子尺寸表.webp',
                buyLink:
                    'https://forms.gle/uM7HkFfMw4XU9EjY9',
                price: 700,
                inStock: false,
                image: '/image/product/2022-8/CARRYON 22S_S August Logo 長襪 一組',
                fittingDesc: [['N/A']],
                desc: `CARRY ON 22SS August 夏季別注系列 Logo 長襪 一組
        
                夏季別注系列以基本Logo作為設計，
                將生活中所追求的突破與創新，與品牌理念融合，
                首次推出運動毛巾底 Logo 長襪，                                    
                腳趾、腳底、腳踝三段式加厚保護，既舒適又排汗，CP值滿分！     
                                                                                                                 
                - 產品成分：棉 (精梳) 62%、彈性纖維16% 、膠絲 (莱卡) 14%、尼龍 8%                                                                                                  
              
                - 本產品使用運動毛巾底，舒適排汗，材質富有彈性，耐磨耐穿，四季皆適。
                
                - 注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨 。                                       "
                `,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-8/decs/22SSAugustSocks-Double/1.webp',
                    '/image/product/2022-8/decs/22SSAugustSocks-Double/2.webp',
                    '/image/product/2022-8/decs/22SSAugustSocks-Double/3.webp',
                    '/image/product/2022-8/decs/22SSAugustSocks-Double/4.webp',
                    '/image/product/2022-8/decs/22SSAugustSocks-Double/5.webp',
                    '/image/product/2022-8/decs/22SSAugustSocks-Double/6.webp',
                    '/image/product/2022-8/decs/22SSAugustSocks-Double/7.webp',
                    '/image/product/2022-8/decs/22SSAugustSocks-Double/8.webp',
                ],
            },
            {
                sku: '22SSAugustSocks-BK1',
                caption: 'CARRYON 22S/S August Logo 長襪  黑',
                spec: 'One Size',
                specImg: '/image/product/2022-8/decs/襪子尺寸表.webp',
                buyLink:
                    'https://forms.gle/uM7HkFfMw4XU9EjY9',
                price: 380,
                inStock: false,
                image: '/image/product/2022-8/CARRYON 22S_S August Logo 長襪 黑色',
                fittingDesc: [['N/A']],
                desc: `CARRY ON 22SS August 夏季別注系列 Logo 長襪 黑
        
                夏季別注系列以基本Logo作為設計，
                將生活中所追求的突破與創新，與品牌理念融合，
                首次推出運動毛巾底 Logo 長襪，                                    
                腳趾、腳底、腳踝三段式加厚保護，既舒適又排汗，CP值滿分！     
                                                                                                                 
                - 產品成分：棉 (精梳) 62%、彈性纖維16% 、膠絲 (莱卡) 14%、尼龍 8%                                                                                                  
              
                - 本產品使用運動毛巾底，舒適排汗，材質富有彈性，耐磨耐穿，四季皆適。
                
                - 注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨 。                                       "
                `,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-8/decs/22SSAugustSocks-BK1/1.webp',
                    '/image/product/2022-8/decs/22SSAugustSocks-BK1/2.webp',
                    '/image/product/2022-8/decs/22SSAugustSocks-BK1/3.webp',
                    '/image/product/2022-8/decs/22SSAugustSocks-BK1/4.webp',
                    '/image/product/2022-8/decs/22SSAugustSocks-BK1/5.webp',
                    '/image/product/2022-8/decs/22SSAugustSocks-BK1/6.webp',
                ],
            },

            {
                sku: '22SSAugustSocks-WH1',
                caption: 'CARRYON 22S/S August Logo 長襪  白',
                spec: 'One Size',
                specImg: '/image/product/2022-8/decs/襪子尺寸表.webp',
                buyLink:
                    'https://forms.gle/uM7HkFfMw4XU9EjY9',
                price: 380,
                inStock: false,
                image: '/image/product/2022-8/CARRYON 22S_S August Logo 長襪 白色',
                fittingDesc: [['N/A']],
                desc: `CARRY ON 22SS August 夏季別注系列 Logo 長襪 白
        
                夏季別注系列以基本Logo作為設計，
                將生活中所追求的突破與創新，與品牌理念融合，
                首次推出運動毛巾底 Logo 長襪，                                    
                腳趾、腳底、腳踝三段式加厚保護，既舒適又排汗，CP值滿分！     
                                                                                                                 
                - 產品成分：棉 (精梳) 62%、彈性纖維16% 、膠絲 (莱卡) 14%、尼龍 8%                                                                                                  
              
                - 本產品使用運動毛巾底，舒適排汗，材質富有彈性，耐磨耐穿，四季皆適。
                
                - 注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨 。                                       "
                `,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-8/decs/22SSAugustSocks-WH1/1.webp',
                    '/image/product/2022-8/decs/22SSAugustSocks-WH1/2.webp',
                    '/image/product/2022-8/decs/22SSAugustSocks-WH1/3.webp',
                    '/image/product/2022-8/decs/22SSAugustSocks-WH1/4.webp',
                    '/image/product/2022-8/decs/22SSAugustSocks-WH1/5.webp',
                    '/image/product/2022-8/decs/22SSAugustSocks-WH1/6.webp',
                ],
            },

            {
                sku: '22ssAugustTee-BK1',
                caption: 'CARRYON 22S/S 經典 Logo 短T 黑',
                spec: 'XL-3XL',
                specImg: '/image/product/2022-8/decs/22ssAugustTee-BK1/size.webp',
                buyLink: 'https://forms.gle/JStBLJJbTV7VfEbX7',
                price: 980,
                inStock: false,
                image: '/image/product/2022-8/CARRYON 22S_S  經典 Logo 短T 黑',
                fittingDesc: [
                    ['Female', 'Height：160cm', 'Weight：44kg', 'Size：2XL', '寬鬆'],
                    ['Male', 'Height：180cm', 'Weight：61kg', 'Size：3XL', '寬鬆'],
                    ['Male', 'Height：174cm', 'Weight：63kg', 'Size：2XL', '寬鬆'],
                ],
                desc: `CARRY ON 22SS August
                夏季別注系列  經典 Logo 短T 黑
        
                堅持，可以是心酸，可以是甜膩，而在歷經了不同階段的挑戰後，是時候停下腳步，看看自己現在的樣子，並給予自己一份肯定。
              
                夏季別注系列以基本Logo作為設計，將那些生活中所追求的突破與創新，與品牌理念融合，跟著我們回顧經典，擁抱創新，向過去的自己致敬，並與未來的自己說聲繼續加油！
                                                                                                                              
              
               - 材質採用台灣棉質製成，白色款式特別使用不透膚材質，穿著上如果流汗後不再怕太透。
              
               - 注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨。
                `,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-8/decs/22ssAugustTee-BK1/1.webp',
                    '/image/product/2022-8/decs/22ssAugustTee-BK1/2.webp',
                    '/image/product/2022-8/decs/22ssAugustTee-BK1/3.webp',
                    '/image/product/2022-8/decs/22ssAugustTee-BK1/4.webp',
                    '/image/product/2022-8/decs/22ssAugustTee-BK1/4-2.webp',
                    '/image/product/2022-8/decs/22ssAugustTee-BK1/5.webp',
                    '/image/product/2022-8/decs/22ssAugustTee-BK1/7.webp',
                ],
            },
            {
                sku: '22ssAugustTee-WH1',
                caption: 'CARRYON 22S/S 經典 Logo 短T 白',
                spec: 'XL-3XL',
                specImg: '/image/product/2022-8/decs/22ssAugustTee-WH1/size.webp',
                buyLink: 'https://forms.gle/JStBLJJbTV7VfEbX7',
                price: 980,
                inStock: false,
                image: '/image/product/2022-8/CARRYON 22S_S 經典 Logo 短T 白',
                fittingDesc: [
                    ['Female', 'Height：160cm', 'Weight：44kg', 'Size：2XL', '寬鬆'],
                    ['Male', 'Height：180cm', 'Weight：61kg', 'Size：3XL', '寬鬆'],
                    ['Male', 'Height：174cm', 'Weight：63kg', 'Size：2XL', '寬鬆'],
                ],
                desc: `CARRY ON 22SS August
                夏季別注系列  經典 Logo 短T 白
        
                堅持，可以是心酸，可以是甜膩，而在歷經了不同階段的挑戰後，是時候停下腳步，看看自己現在的樣子，並給予自己一份肯定。
              
                夏季別注系列以基本Logo作為設計，將那些生活中所追求的突破與創新，與品牌理念融合，跟著我們回顧經典，擁抱創新，向過去的自己致敬，並與未來的自己說聲繼續加油！
                                               
                                                                                                                       
         - 材質採用台灣棉質製成，白色款式特別使用不透膚材質，穿著上如果流汗後不再怕太透。
        
         - 注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨。
                `,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-8/decs/22ssAugustTee-WH1/1.webp',
                    '/image/product/2022-8/decs/22ssAugustTee-WH1/2.webp',
                    '/image/product/2022-8/decs/22ssAugustTee-WH1/3.webp',
                    '/image/product/2022-8/decs/22ssAugustTee-WH1/4.webp',
                    '/image/product/2022-8/decs/22ssAugustTee-WH1/5.webp',
                    '/image/product/2022-8/decs/22ssAugustTee-WH1/6.webp',
                ],
            },
            {
                sku: '22SSAugustCropTee-BK1',
                caption: 'CARRYON 22S/S 經典 Logo 短版T 黑',
                spec: 'M-XL',
                specImg: '/image/product/2022-8/decs/22SSAugustCropTee-BK1/size.webp',
                buyLink: 'https://forms.gle/JStBLJJbTV7VfEbX7',
                price: 880,
                inStock: false,
                image: '/image/product/2022-8/CARRYON 22S_S 經典 Logo 短版T  黑',
                fittingDesc: [
                    ['Female', 'Height：161cm', 'Weight：43kg', 'Size：M', '合適'],
                    ['Female', 'Height：163cm', 'Weight：49kg', 'Size：M', '合適'],
                ],
                desc: `CARRY ON 22SS August
                夏季別注系列  經典 Logo 短版T 黑
        
                CARRYON 首次開箱專屬女孩們的夏日戰服！
                夏季別注系列以基本Logo作為設計，親膚材質不悶熱，簡約設計可甜可鹹，怎樣麼搭都不膩～
                                                                                                                        
               - 此單品為限量發售，售完不補貨。                                                                                                               
              
               - 注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨
                `,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-8/decs/22SSAugustCropTee-BK1/1.webp',
                    '/image/product/2022-8/decs/22SSAugustCropTee-BK1/2.webp',
                    '/image/product/2022-8/decs/22SSAugustCropTee-BK1/3.webp',
                    '/image/product/2022-8/decs/22SSAugustCropTee-BK1/4.webp',
                    '/image/product/2022-8/decs/22SSAugustCropTee-BK1/5.webp',
                ],
            },
            {
                sku: '22SSAugustCropTee-WH1',
                caption: 'CARRYON 22S/S 經典 Logo 短版T 白',
                spec: 'M-XL',
                specImg: '/image/product/2022-8/decs/22SSAugustCropTee-WH1/size.webp',
                buyLink: 'https://forms.gle/JStBLJJbTV7VfEbX7',
                price: 880,
                inStock: false,
                image: '/image/product/2022-8/CARRYON 22S_S 經典 Logo 短版T  白',
                fittingDesc: [
                    ['Female', 'Height：161cm', 'Weight：43kg', 'Size：M', '合適'],
                    ['Female', 'Height：163cm', 'Weight：49kg', 'Size：M', '合適'],
                ],
                desc: `CARRY ON 22SS August
                夏季別注系列  經典 Logo 短版T 白
        
                CARRYON 首次開箱專屬女孩們的夏日戰服！
                夏季別注系列以基本Logo作為設計，親膚材質不悶熱，簡約設計可甜可鹹，怎樣麼搭都不膩～
                                                                                                                        
               - 此單品為限量發售，售完不補貨。                                                                                                               
              
               - 注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨
                `,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-8/decs/22SSAugustCropTee-WH1/1.webp',
                    '/image/product/2022-8/decs/22SSAugustCropTee-WH1/2.webp',
                    '/image/product/2022-8/decs/22SSAugustCropTee-WH1/3.webp',
                    '/image/product/2022-8/decs/22SSAugustCropTee-WH1/4.webp',
                    '/image/product/2022-8/decs/22SSAugustCropTee-WH1/5.webp',
                ],
            },

            {
                sku: '22SSAugustJeans-BK1',
                caption: '［預購］CARRYON 22S/S August 電繡牛仔褲 黑',
                spec: '28, 30, 32, 34, 36',
                specImg: '/image/product/2022-8/decs/22SSAugustJeans-BK1/size.webp',
                buyLink: 'https://forms.gle/JStBLJJbTV7VfEbX7',
                price: 1580,
                inStock: false,
                image: '/image/product/2022-8/CARRYON 22S_S August 電繡牛仔褲 黑',
                fittingDesc: [
                    ['Female', 'Height：163cm', 'Weight：49kg', 'Size：32', '寬鬆'],
                    ['Female', 'Height：160cm', 'Weight：44kg', 'Size：30', '寬鬆'],
                    ['Male', 'Height：180cm', 'Weight：61kg', 'Size：34', '寬鬆'],
                    ['Male', 'Height：174cm', 'Weight：63kg', 'Size：32', '寬鬆'],
                ],
                desc: `CARRY ON 22SS August
                夏季別注系列  電繡牛仔褲 黑
        
           CARRYON 首發單品第二彈 還未出就被問爆的 電繡牛仔褲！前方口袋採用 大C 電繡設計，後方口袋則有 CARRYON Logo 字樣，前後呼應品牌理念， 水洗直筒寬鬆版型，質料扎實不厚重，穿搭靠這條牛仔褲回頭率絕對超高！                                                                                                      
                                                                                                                     
         - 單品材質為水洗牛仔，褲型直筒，版型寬鬆偏大，購買前請對照尺寸表，確認完畢再下單！
        
         - 注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨。
                `,
                prodDescImgs: [
                    '/image/product/2022-8/CARRYON 22S_S August 電繡牛仔褲 黑--md.webp',
                    '/image/product/2022-8/CARRYON 22S_S August 電繡牛仔褲 黑-2--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-8/decs/22SSAugustJeans-BK1/1.webp',
                    '/image/product/2022-8/decs/22SSAugustJeans-BK1/1-2.webp',
                    '/image/product/2022-8/decs/22SSAugustJeans-BK1/2.webp',
                    '/image/product/2022-8/decs/22SSAugustJeans-BK1/3.webp',
                    '/image/product/2022-8/decs/22SSAugustJeans-BK1/4.webp',
                    '/image/product/2022-8/decs/22SSAugustJeans-BK1/5.webp',
                    '/image/product/2022-8/decs/22SSAugustJeans-BK1/6.webp',
                    '/image/product/2022-8/decs/22SSAugustJeans-BK1/7.webp',
                ],
            },
            {
                sku: '22SSAugustJeans-B1',
                caption: '［預購］CARRYON 22S/S August 電繡牛仔褲 藍',
                spec: '28, 30, 32, 34, 36',
                specImg: '/image/product/2022-8/decs/22SSAugustJeans-B1/size.webp',
                buyLink: 'https://forms.gle/JStBLJJbTV7VfEbX7',
                price: 1580,
                inStock: false,
                image: '/image/product/2022-8/CARRYON 22S_S August 電繡牛仔褲 藍',
                fittingDesc: [
                    ['Female', 'Height：163cm', 'Weight：49kg', 'Size：32', '寬鬆'],
                    ['Female', 'Height：160cm', 'Weight：44kg', 'Size：30', '寬鬆'],
                    ['Male', 'Height：180cm', 'Weight：61kg', 'Size：34', '寬鬆'],
                    ['Male', 'Height：174cm', 'Weight：63kg', 'Size：32', '寬鬆'],
                ],
                desc: `CARRY ON 22SS August
                夏季別注系列  電繡牛仔褲 藍
        
                CARRYON 首發單品第二彈 還未出就被問爆的 電繡牛仔褲！前方口袋採用 大C 電繡設計，後方口袋則有 CARRYON Logo 字樣，前後呼應品牌理念， 水洗直筒寬鬆版型，質料扎實不厚重，穿搭靠這條牛仔褲回頭率絕對超高！
                                                                                                                           
               - 單品材質為水洗牛仔，褲型直筒，版型寬鬆偏大，購買前請對照尺寸表，確認完畢再下單！
              
               - 注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨。
                `,
                prodDescImgs: [
                    '/image/product/2022-8/CARRYON 22S_S August 電繡牛仔褲 藍--md.webp',
                    '/image/product/2022-8/CARRYON 22S_S August 電繡牛仔褲 藍-2--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-8/decs/22SSAugustJeans-B1/1.webp',
                    '/image/product/2022-8/decs/22SSAugustJeans-B1/1-1.webp',
                    '/image/product/2022-8/decs/22SSAugustJeans-B1/2.webp',
                    '/image/product/2022-8/decs/22SSAugustJeans-B1/3.webp',
                    '/image/product/2022-8/decs/22SSAugustJeans-B1/4.webp',
                    '/image/product/2022-8/decs/22SSAugustJeans-B1/5.webp',
                    '/image/product/2022-8/decs/22SSAugustJeans-B1/6.webp',
                    '/image/product/2022-8/decs/22SSAugustJeans-B1/7.webp',
                ],
            },

            {
                sku: '22SSAugustSideBag-BK1',
                caption: '［預購］CARRYON 22S/S August 機能扣環大容量側背包 黑',
                spec: 'One Size',
                specImg: '/image/product/2022-8/decs/22SSAugustSideBag-BK1/size.webp',
                buyLink: 'https://forms.gle/JStBLJJbTV7VfEbX7',
                price: 1280,
                inStock: false,
                image:
                    '/image/product/2022-8/CARRYON 22S_S August 機能扣環大容量側背包 黑',
                fittingDesc: [['N/A']],
                desc: `CARRY ON 22SS August
                夏季別注系列 機能扣環大容量側背包 黑
        
                夏季別注系列以基本Logo作為設計，推出機能扣環大容量側背包，多層收納夾層，氣墊背帶，機能設計，好看又實用！
               
                                                                                                                           
               - 內含兩大收納夾層、兩小收納夾層，可容納14吋筆                                                                                                            
              
               - 面料為尼龍防潑水材質
               
               - 背袋含機能扣環，AirPods、鑰匙圈掛取方便好攜帶
              
               - 注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨。
                `,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-8/decs/22SSAugustSideBag-BK1/1.webp',
                    '/image/product/2022-8/decs/22SSAugustSideBag-BK1/2.webp',
                    '/image/product/2022-8/decs/22SSAugustSideBag-BK1/4.webp',
                    '/image/product/2022-8/decs/22SSAugustSideBag-BK1/5.webp',
                    '/image/product/2022-8/decs/22SSAugustSideBag-BK1/6.webp',
                    '/image/product/2022-8/decs/22SSAugustSideBag-BK1/7.webp',
                    '/image/product/2022-8/decs/22SSAugustSideBag-BK1/8.webp',
                ],
            },
            {
                sku: '22SSAugustSideBag-WH1',
                caption: 'CARRYON 22S/S August 機能扣環大容量側背包 白',
                spec: 'One Size',
                specImg: '/image/product/2022-8/decs/22SSAugustSideBag-WH1/size.webp',
                buyLink: 'https://forms.gle/JStBLJJbTV7VfEbX7',
                price: 1280,
                inStock: false,
                image:
                    '/image/product/2022-8/CARRYON 22S_S August 機能扣環大容量側背包 灰白',
                fittingDesc: [['N/A']],
                desc: `CARRY ON 22SS August
                夏季別注系列 機能扣環大容量側背包 白
        
                夏季別注系列以基本Logo作為設計，推出機能扣環大容量側背包，多層收納夾層，氣墊背帶，機能設計，好看又實用！
               
                                                                                                                           
               - 內含兩大收納夾層、兩小收納夾層，可容納14吋筆                                                                                                            
              
               - 面料為尼龍防潑水材質
               
               - 背袋含機能扣環，AirPods、鑰匙圈掛取方便好攜帶
              
               - 注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨。
                `,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-8/decs/22SSAugustSideBag-WH1/1.webp',
                    '/image/product/2022-8/decs/22SSAugustSideBag-WH1/2.webp',
                    '/image/product/2022-8/decs/22SSAugustSideBag-WH1/3.webp',
                    '/image/product/2022-8/decs/22SSAugustSideBag-WH1/4.webp',
                    '/image/product/2022-8/decs/22SSAugustSideBag-WH1/5.webp',
                    '/image/product/2022-8/decs/22SSAugustSideBag-WH1/6.webp',
                ],
            },

            {
                sku: '22SSAugustCap-BK1',
                caption: 'CARRYON 22S/S  經典 Logo 電繡老帽',
                spec: 'One Size',
                specImg: '/image/product/2022-8/decs/22SSAugustCap-BK1/size.webp',
                buyLink: 'https://forms.gle/JStBLJJbTV7VfEbX7',
                price: 980,
                inStock: true,
                image: '/image/product/2022-8/CARRYON 22S_S  經典 Logo 刺繡老帽',
                fittingDesc: [['N/A']],
                desc: `CARRY ON 22SS August
                夏季別注系列 經典 Logo 電繡老帽
          
                夏季別注系列釋出多項新穎單品，迎接CARRYON 邁入的第三年，再次釋出經典不敗 Logo 電繡老帽， 感謝一路陪伴 CARRYON 的所有人             
                
                讓我們繼續堅持所有，成為自己想要的樣子，感謝過去堅持的自己，感謝身旁帶給你力量的那些愛人們。                                                                                                      
                                                                                                                      
                - 電繡 Logo                                                                                                            
               
                - 100%斜紋面料質感
                
                - 含調節式扣環，可調整大小
               
                - 帽圍：55-60 cm
               
                - 注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨。
                `,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-8/decs/22SSAugustCap-BK1/1.webp',
                    '/image/product/2022-8/decs/22SSAugustCap-BK1/2.webp',
                    '/image/product/2022-8/decs/22SSAugustCap-BK1/3.webp',
                    '/image/product/2022-8/decs/22SSAugustCap-BK1/4.webp',
                    '/image/product/2022-8/decs/22SSAugustCap-BK1/5.webp',
                ],
            },
        ],
    },
    {
        name: 'CARRYON 22SS',
        list: [
            {
                sku: '22ssTEE-BK1',
                caption: 'CARRYON 22S/S 塗鴉短袖 紫黃 黑',
                spec: 'XL-3XL',
                specImg:
                    '/image/product/2022-1/carryon 22ss_塗鴉短袖紫黑黃.webp?20220409',
                buyLink: 'https://forms.gle/7cENmV3sy1GA5iXQA',
                price: 980,
                inStock: false,
                image: '/image/product/2022-1/22ssTEE-BK1',
                fittingDesc: [
                    ['Female', 'Height：160cm', 'Weight：48kg', 'Size：2XL', '寬鬆'],
                ],
                desc: `CARRYON 22SS 春夏新品概念
        
                將「毅力不搖」的意念轉化成「山」的圖樣，注入 CARRYON Logo ，並加入塗鴉元素，呈現全新的 Logo 概念，在服飾背面中間也保留原始 Logo，前後呼應對於堅持精神的傳遞！
                
                本季服飾皆為自製版型，衣服寬度及肩線比以往更大！購買前務必看數據參考下單。
                
                材質採用台灣棉質製成，白色款式特別使用不透膚材質，穿著上如果流汗後不再怕太透。
                
                注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨
                `,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-1/desc/22ssTEE-5.webp',
                    '/image/product/2022-1/desc/22ssTEE-1.webp',
                    '/image/product/2022-1/desc/22ssTEE-2.webp',
                    '/image/product/2022-1/desc/22ssTEE-3.webp',
                ],
            },
            {
                sku: '22ssTEE-WH1',
                caption: 'CARRYON 22S/S 塗鴉短袖 藍綠 白',
                spec: 'XL-3XL',
                specImg:
                    '/image/product/2022-1/carryon 22ss_塗鴉短袖藍綠白.webp?20220409',
                buyLink: 'https://forms.gle/7cENmV3sy1GA5iXQA',
                price: 980,
                inStock: false,
                image: '/image/product/2022-1/22ssTEE-WH1',
                fittingDesc: [
                    ['Female', 'Height：160cm', 'Weight：48kg', 'Size：2XL', '寬鬆'],
                ],
                desc: `CARRYON 22SS 春夏新品概念
        
                將「毅力不搖」的意念轉化成「山」的圖樣，注入 CARRYON Logo ，並加入塗鴉元素，呈現全新的 Logo 概念，在服飾背面中間也保留原始 Logo，前後呼應對於堅持精神的傳遞！
                
                本季服飾皆為自製版型，衣服寬度及肩線比以往更大！購買前務必看數據參考下單。
                
                材質採用台灣棉質製成，白色款式特別使用不透膚材質，穿著上如果流汗後不再怕太透。
                
                注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨
                `,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-1/desc/22ssTEE-4.webp',
                    '/image/product/2022-1/desc/22ssTEE-1.webp',
                    '/image/product/2022-1/desc/22ssTEE-2.webp',
                    '/image/product/2022-1/desc/22ssTEE-3.webp',
                ],
            },
            {
                sku: '22ssLS-BK1',
                caption: 'CARRYON 22S/S 塗鴉長袖 藍字 黑',
                spec: 'XL-3XL',
                specImg:
                    '/image/product/2022-1/carryon 22ss_塗鴉長袖藍字黑.webp?20220409',
                buyLink: 'https://forms.gle/7cENmV3sy1GA5iXQA',
                price: 1080,
                inStock: false,
                image: '/image/product/2022-1/22ssLS-BK1',
                fittingDesc: [
                    ['Female', 'Height：160cm', 'Weight：48kg', 'Size：2XL', '寬鬆'],
                ],
                desc: `CARRYON 22SS 春夏新品概念
        
                將「毅力不搖」的意念轉化成「山」的圖樣，注入 CARRYON Logo ，並加入塗鴉元素，呈現全新的 Logo 概念，在服飾背面中間也保留原始 Logo，前後呼應對於堅持精神的傳遞！
                
                本季服飾皆為自製版型，衣服寬度及肩線比以往更大！購買前務必看數據參考下單。
                
                材質採用台灣棉質製成，白色款式特別使用不透膚材質，穿著上如果流汗後不再怕太透。
                
                注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨
                `,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-1/desc/22ssLS-4.webp',
                    '/image/product/2022-1/desc/22ssLS-3.webp',
                    '/image/product/2022-1/desc/22ssLS-1.webp',
                    '/image/product/2022-1/desc/22ssLS-2.webp',
                ],
            },
            {
                sku: '22ssLS-WH1',
                caption: 'CARRYON 22S/S 塗鴉長袖 黑字 白',
                spec: 'XL-3XL',
                specImg:
                    '/image/product/2022-1/carryon 22ss_塗鴉長袖黑字白.webp?20220409',
                buyLink: 'https://forms.gle/7cENmV3sy1GA5iXQA',
                price: 1080,
                inStock: false,
                image: '/image/product/2022-1/22ssLS-WH1',
                fittingDesc: [
                    ['Female', 'Height：160cm', 'Weight：48kg', 'Size：2XL', '寬鬆'],
                ],
                desc: `CARRYON 22SS 春夏新品概念
        
                將「毅力不搖」的意念轉化成「山」的圖樣，注入 CARRYON Logo ，並加入塗鴉元素，呈現全新的 Logo 概念，在服飾背面中間也保留原始 Logo，前後呼應對於堅持精神的傳遞！
                
                本季服飾皆為自製版型，衣服寬度及肩線比以往更大！購買前務必看數據參考下單。
                
                材質採用台灣棉質製成，白色款式特別使用不透膚材質，穿著上如果流汗後不再怕太透。
                
                注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨
                `,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-1/desc/22ssLS-1.webp',
                    '/image/product/2022-1/desc/22ssLS-2.webp',
                ],
            },

            {
                sku: '202capGR-1',
                caption: 'CARRYON 22S/S 刺繡 燈芯絨 短帽沿',
                spec: 'One Size',
                specImg: null,
                buyLink: 'https://forms.gle/7cENmV3sy1GA5iXQA',
                price: 980,
                inStock: false,
                image: '/image/product/2022-1/202capGR-1',
                fittingDesc: [['N/A']],
                desc: `CARRYON 22S/S 刺繡 燈芯絨 短帽沿
        
                - 刺繡 Logo
                
                - 含調節式扣環，可調整大小
                
                - 帽圍：56-58 cm 
                
                清洗方式：使用牙刷沾上稀釋後的洗衣劑，將髒污的地方進行刷洗，再使用濕抹布清潔，完成後再務必用乾布或紙巾，支撐帽型確保風乾時不會變形。
                `,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-1/desc/cap-1.webp',
                    '/image/product/2022-1/desc/cap-2.webp',
                    '/image/product/2022-1/desc/cap-3.webp',
                    '/image/product/2022-1/desc/cap-4.webp',
                    '/image/product/2022-1/desc/cap-5.webp',
                    '/image/product/2022-1/desc/cap-6.webp',
                ],
            },
            {
                sku: '22sscapBK-1',
                caption: 'CARRYON 22S/S 刺繡 水洗 短帽沿  黑色',
                spec: 'One Size',
                specImg: null,
                buyLink: 'https://forms.gle/7cENmV3sy1GA5iXQA',
                price: 980,
                inStock: false,
                image: '/image/product/2022-1/22sscapBK-1',
                fittingDesc: [['N/A']],
                desc: `CARRYON 22S/S 刺繡 水洗 短帽沿 黑色
        
                - 刺繡 Logo
                
                - 水洗面料質感
                
                - 含調節式扣環，可調整大小
                
                - 帽圍：56-58 cm
                
                清洗方式：使用牙刷沾上稀釋後的洗衣劑，將髒污的地方進行刷洗，再使用濕抹布清潔，完成後再務必用乾布或紙巾，支撐帽型確保風乾時不會變形。
                `,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-1/desc/cap-1.webp',
                    '/image/product/2022-1/desc/cap-2.webp',
                    '/image/product/2022-1/desc/cap-3.webp',
                    '/image/product/2022-1/desc/cap-4.webp',
                    '/image/product/2022-1/desc/cap-5.webp',
                    '/image/product/2022-1/desc/cap-6.webp',
                ],
            },
            {
                sku: '22sscapGR-1',
                caption: 'CARRYON 22S/S 刺繡 水洗 短帽沿  軍綠',
                spec: 'One Size',
                specImg: null,
                buyLink: 'https://forms.gle/7cENmV3sy1GA5iXQA',
                price: 980,
                inStock: false,
                image: '/image/product/2022-1/22sscapGR-1',
                fittingDesc: [['N/A']],
                desc: `CARRYON 22S/S 刺繡 水洗 短帽沿 軍綠
        
                - 刺繡 Logo
                
                - 水洗面料質感
                
                - 含調節式扣環，可調整大小
                
                - 帽圍：56-58 cm
                
                清洗方式：使用牙刷沾上稀釋後的洗衣劑，將髒污的地方進行刷洗，再使用濕抹布清潔，完成後再務必用乾布或紙巾，支撐帽型確保風乾時不會變形。
                `,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-1/desc/cap-1.webp',
                    '/image/product/2022-1/desc/cap-2.webp',
                    '/image/product/2022-1/desc/cap-3.webp',
                    '/image/product/2022-1/desc/cap-4.webp',
                    '/image/product/2022-1/desc/cap-5.webp',
                    '/image/product/2022-1/desc/cap-6.webp',
                ],
            },
            {
                sku: '22sscapKA-1',
                caption: 'CARRYON 22S/S 刺繡 水洗 短帽沿  卡其',
                spec: 'One Size',
                specImg: null,
                buyLink: 'https://forms.gle/7cENmV3sy1GA5iXQA',
                price: 980,
                inStock: false,
                image: '/image/product/2022-1/22sscapKA-1',
                fittingDesc: [['N/A']],
                desc: `CARRYON 22S/S 刺繡 水洗 短帽沿 卡其
        
                - 刺繡 Logo
                
                - 水洗面料質感
                
                - 含調節式扣環，可調整大小
                
                - 帽圍：56-58 cm
                
                清洗方式：使用牙刷沾上稀釋後的洗衣劑，將髒污的地方進行刷洗，再使用濕抹布清潔，完成後再務必用乾布或紙巾，支撐帽型確保風乾時不會變形。
                `,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-1/desc/cap-1.webp',
                    '/image/product/2022-1/desc/cap-2.webp',
                    '/image/product/2022-1/desc/cap-3.webp',
                    '/image/product/2022-1/desc/cap-4.webp',
                    '/image/product/2022-1/desc/cap-5.webp',
                    '/image/product/2022-1/desc/cap-6.webp',
                ],
            },
            {
                sku: '22ssbucketBK-1',
                caption: 'CARRYON 22S/S 刺繡 水洗 漁夫帽  黑色',
                spec: 'One Size',
                specImg: null,
                buyLink: 'https://forms.gle/7cENmV3sy1GA5iXQA',
                price: 980,
                inStock: false,
                image: '/image/product/2022-1/22ssbucketBK-1',
                fittingDesc: [['N/A']],
                desc: `CARRYON 22S/S 刺繡 水洗 漁夫帽 黑色
        
                - 刺繡 Logo
                
                - 水洗面料質感
                
                - 帽圍：56-58 cm
                
                清洗方式：使用牙刷沾上稀釋後的洗衣劑，將髒污的地方進行刷洗，再使用濕抹布清潔，完成後再務必用乾布或紙巾，支撐帽型確保風乾時不會變形。
                `,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-1/desc/cap-1.webp',
                    '/image/product/2022-1/desc/cap-2.webp',
                    '/image/product/2022-1/desc/cap-3.webp',
                    '/image/product/2022-1/desc/cap-4.webp',
                    '/image/product/2022-1/desc/cap-5.webp',
                    '/image/product/2022-1/desc/cap-6.webp',
                ],
            },
            {
                sku: '22ssbucketNe-1',
                caption: 'CARRYON 22S/S 刺繡 水洗 漁夫帽  海軍藍',
                spec: 'One Size',
                specImg: null,
                buyLink: 'https://forms.gle/7cENmV3sy1GA5iXQA',
                price: 980,
                inStock: false,
                image: '/image/product/2022-1/22ssbucketNe-1',
                fittingDesc: [['N/A']],
                desc: `CARRYON 22S/S 刺繡 水洗 漁夫帽  海軍藍
        
                - 刺繡 Logo
                
                - 水洗面料質感
                
                - 帽圍：56-58 cm
                
                清洗方式：使用牙刷沾上稀釋後的洗衣劑，將髒污的地方進行刷洗，再使用濕抹布清潔，完成後再務必用乾布或紙巾，支撐帽型確保風乾時不會變形。
                `,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2022-1/desc/cap-1.webp',
                    '/image/product/2022-1/desc/cap-2.webp',
                    '/image/product/2022-1/desc/cap-3.webp',
                    '/image/product/2022-1/desc/cap-4.webp',
                    '/image/product/2022-1/desc/cap-5.webp',
                    '/image/product/2022-1/desc/cap-6.webp',
                ],
            },
        ],
    },
    {
        name: 'CARRYON 21FW',
        list: [
            {
                sku: '2021hoodie-BK-1',
                caption: 'CARRYON hoodie 連帽上衣 黑色',
                spec: 'L-3XL',
                specImg: '/image/product/size.webp',
                buyLink: 'https://forms.gle/9BuJ1ER5zB6dCwSi9',
                price: 1580,
                inStock: false,
                image: '/image/product/2021-5/2021hoodie-BK-1',
                fittingDesc: [
                    ['Female', 'Height：160cm', 'Weight：48kg', 'Size：2XL', '寬鬆'],
                ],
                desc: `CARRYON 全新概念

                長大後，每到不同階段、角色的轉換，將面對不可避免的現實問題

                各種情緒湧上心頭

                焦慮、緊張、壓力隨之而來

                要苟同現實，還是堅持夢想？

                CARRYON 將面對現實的情緒，緊張、壓力、焦慮感等感受注入設計理念中，背後充斥著不同情緒的狀態
                選用舒適優質布料構成，表層防寒、內裡刷毛保暖，且不容易起毛球，限量發售千萬不可錯過～

                注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨`,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-BK-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-BK-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2021-5/desc/2021hoodie-BK-1-1.webp',
                    '/image/product/2021-5/desc/2021hoodie-BK-1-2.webp',
                    '/image/product/2021-5/desc/2021hoodie-BK-1-3.webp',
                    '/image/product/2021-5/desc/2021hoodie-BK-1-4.webp',
                ],
            },
            {
                sku: '2021hoodie-W-1',
                caption: 'CARRYON hoodie 連帽上衣 白色',
                spec: 'L-3XL',
                specImg: '/image/product/size.webp',
                buyLink: 'https://forms.gle/9BuJ1ER5zB6dCwSi9',
                price: 1580,
                inStock: false,
                image: '/image/product/2021-5/2021hoodie-W-1',
                fittingDesc: [
                    ['Female', 'Height：160cm', 'Weight：48kg', 'Size：2XL', '寬鬆'],
                ],
                desc: `CARRYON 全新概念

                長大後，每到不同階段、角色的轉換，將面對不可避免的現實問題

                各種情緒湧上心頭

                焦慮、緊張、壓力隨之而來

                要苟同現實，還是堅持夢想？

                CARRYON 將面對現實的情緒，緊張、壓力、焦慮感等感受注入設計理念中，背後充斥著不同情緒的狀態
                選用舒適優質布料構成，表層防寒、內裡刷毛保暖，且不容易起毛球，限量發售千萬不可錯過～

                注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨`,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-W-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-W-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2021-5/desc/2021hoodie-W-1-1.webp',
                    '/image/product/2021-5/desc/2021hoodie-W-1-2.webp',
                    '/image/product/2021-5/desc/2021hoodie-W-1-3.webp',
                    '/image/product/2021-5/desc/2021hoodie-W-1-4.webp',
                ],
            },
            {
                sku: '2021hoodie-B-1',
                caption: 'CARRYON hoodie 連帽上衣 藍色',
                spec: 'L-3XL',
                specImg: '/image/product/size.webp',
                buyLink: 'https://forms.gle/9BuJ1ER5zB6dCwSi9',
                price: 1580,
                inStock: false,
                image: '/image/product/2021-5/2021hoodie-B-1',
                fittingDesc: [
                    ['Female', 'Height：160cm', 'Weight：48kg', 'Size：2XL', '寬鬆'],
                ],
                desc: `CARRYON 全新概念

                長大後，每到不同階段、角色的轉換，將面對不可避免的現實問題

                各種情緒湧上心頭

                焦慮、緊張、壓力隨之而來

                要苟同現實，還是堅持夢想？

                CARRYON 將面對現實的情緒，緊張、壓力、焦慮感等感受注入設計理念中，背後充斥著不同情緒的狀態
                選用舒適優質布料構成，表層防寒、內裡刷毛保暖，且不容易起毛球，限量發售千萬不可錯過～

                注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨`,
                prodDescImgs: [
                    // '/image/product/2021-5/2021hoodie-B-1--d--1--md.webp',
                    // '/image/product/2021-5/2021hoodie-B-1--d--2--md.webp',
                ],
                descImgs: [
                    '/image/product/2021-5/desc/2021hoodie-B-1-1.webp',
                    '/image/product/2021-5/desc/2021hoodie-B-1-2.webp',
                    '/image/product/2021-5/desc/2021hoodie-B-1-3.webp',
                    '/image/product/2021-5/desc/2021hoodie-B-1-4.webp',
                ],
            },
            {
                sku: '2021capBK-1',
                caption: 'CARRYON 5 panel cap 黑灰拼接',
                spec: 'One Size',
                specImg: null,
                buyLink: 'https://forms.gle/E2y8RfLx8whmHWoU8',
                price: 880,
                inStock: false,
                image: '/image/product/2021-5/2021capBK-1',
                fittingDesc: [['N/A']],
                desc: `CARRYON 全新概念

                長大後，每到不同階段、角色的轉換，將面對不可避免的現實問題
                
                各種情緒湧上心頭
                
                焦慮、緊張、壓力隨之而來
                
                要苟同現實，還是堅持夢想？
                
                CARRYON 5 panel cap 置入 2021年 CARRYON 全新概念Logo
                
                - 全速乾聚酯纖維面料
                
                - 含調節式扣環，可調整大小
                
                - 含防潑水機能性
                
                注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨`,
                prodDescImgs: [],
                descImgs: [
                    '/image/product/2021-5/desc/2021capBK-1-1.webp',
                    '/image/product/2021-5/desc/2021capBK-1-2.webp',
                ],
            },
            {
                sku: '2021capG-1',
                caption: 'CARRYON 5 panel cap 藍綠拼接',
                spec: 'One Size',
                specImg: null,
                buyLink: 'https://forms.gle/E2y8RfLx8whmHWoU8',
                price: 880,
                inStock: false,
                image: '/image/product/2021-5/2021capG-1',
                fittingDesc: [['N/A']],
                desc: `CARRYON 全新概念

                長大後，每到不同階段、角色的轉換，將面對不可避免的現實問題
                
                各種情緒湧上心頭
                
                焦慮、緊張、壓力隨之而來
                
                要苟同現實，還是堅持夢想？
                
                CARRYON 5 panel cap 置入 2021年 CARRYON 全新概念Logo
                
                - 全速乾聚酯纖維面料
                
                - 含調節式扣環，可調整大小
                
                - 含防潑水機能性
                
                注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨`,
                prodDescImgs: [],
                descImgs: [
                    '/image/product/2021-5/desc/2021capG-1-1.webp',
                    '/image/product/2021-5/desc/2021capG-1-2.webp',
                ],
            },
            {
                sku: '2021capK-1',
                caption: 'CARRYON 5 panel cap 卡其拼接',
                spec: 'One Size',
                specImg: null,
                buyLink: 'https://forms.gle/E2y8RfLx8whmHWoU8',
                price: 880,
                inStock: false,
                image: '/image/product/2021-5/2021capK-1',
                fittingDesc: [['N/A']],
                desc: `CARRYON 全新概念

                長大後，每到不同階段、角色的轉換，將面對不可避免的現實問題
                
                各種情緒湧上心頭
                
                焦慮、緊張、壓力隨之而來
                
                要苟同現實，還是堅持夢想？
                
                CARRYON 5 panel cap 置入 2021年 CARRYON 全新概念Logo
                
                - 全速乾聚酯纖維面料
                
                - 含調節式扣環，可調整大小
                
                - 含防潑水機能性
                
                注意事項：確認訂購請填寫表單，後續將有客服與您聯絡，確認已匯款金額，少量先製現貨，首購搶先出貨`,
                prodDescImgs: [],
                descImgs: [
                    '/image/product/2021-5/desc/2021capK-1-1.webp',
                    '/image/product/2021-5/desc/2021capK-1-2.webp',
                ],
            },
        ],
    },
];

export default prods;
